const environmentUrl =
  process.env.VUE_APP_BRAND === "oldmutual"
    ? "www.oldmutualwill.co.za"
    : process.env.VUE_APP_BRAND === "teba"
    ? "teba.oldmutualwill.co.za"
    : "quickwill.co.za";

export default {
  environmentUrl: environmentUrl,
  will_async: false,
  brand: "default",
  name: "QuickWill",
  estateAssistEnabled: false,
  landingPageBanner: "general",
  co_branded: {
    co_branded_banner: "",
  },
  bookingsEmailAddress: 'support@oldmutualwill.co.za',
  colors: {
    Onyx: "#282828",
    "light-primary-text-colour": "#282828",
    "Light-Secondary-Text-Colour": "#747474",
    "Light-Button-Stroke": "#DCDDDE",
    "Light-Button-Colour": "#FFF",
    primary: "#3ADEB4",
    secondary: "#FEEB35",
    tertiary: "#ED0080",
    update: "#FF9800",
    "secondary-highlighted-font": "#000000",
    "secondary-button-font": "#000000",
    error: "#b71c1c",
    white: "#FFFFFF",
    warning: "#FA7268",
    grey: "#DFE2E5",
    "text-grey": "#4F4F4F",
    "mid-grey": "#808080",
    "background-grey": "#F6F6F6",
    "font-color": "#2c3e50",
    "cost-orange": "#E9AB21",
    "education-blue": "#6087ED",
    "debt-brown": "#D65E23",
    "cash-green": "#8ABA3E",
    "estate-pink": "#DA1572",
    "quote-payout-green": "#65AF5B",
  },
  images: {
    homepage: {
      heroBarSourceSets: [
        // Has to be empty here and overriden in other config files.
      ],
    },
    referrals: {
      claimable: "quickwill/referrals/claimable.svg",
      emailSent: "quickwill/referrals/email_sent.svg",
      claimed: "quickwill/referrals/claimed.svg",
    },
    logo: "quickwill/primary_logo.png",
    footerLogo: "quickwill/homepage/white-scroll-icon.png",
    homeMain: "quickwill/homepage/zuckerberg-turquoise.png",
    mobileHomeMain: "quickwill/homepage/mobile-main-image.png",
    homeSteps1: "quickwill/homepage/1.png",
    homeSteps2: "quickwill/homepage/2.png",
    homeSteps3: "quickwill/homepage/3.png",
    homeSteps4: "quickwill/homepage/4.png",
    homeSteps5: "quickwill/homepage/5.png",
    homeUsp1: "quickwill/homepage/convenience.png",
    homeUsp2: "quickwill/homepage/robust.png",
    homeUsp3: "quickwill/homepage/support.png",
    homeUsp4: "quickwill/homepage/easyupdates.png",
    homeButtonTileOne: require(`@/assets/shared/redesign/home/Home-Straightforward.jpg`),
    homeButtonTileTwo: require(`@/assets/shared/redesign/home/Home-Customised.jpg`),
    homeButtonTileThree: require(`@/assets/shared/redesign/home/Home-Easy-updates.jpg`),
    home1ButtonTileOne: require(`@/assets/shared/button-tiles/Card1.jpg`),
    home1ButtonTileTwo: require(`@/assets/shared/button-tiles/Card2.jpg`),
    home1ButtonTileThree: require(`@/assets/shared/button-tiles/Card3.jpg`),
    homeInfoTitleOne: "old_mutual/homepage/savings.svg",
    homeInfoTitleTwo: "old_mutual/homepage/data_privacy.svg",
    homeInfoTitleThree: "old_mutual/homepage/support.svg",
    homeInfoTitleFour: "old_mutual/homepage/online_updates.svg",
    articlesOne: "shared/redesign/articles/EstatePlanning.jpg",
    articlesTwo: "shared/redesign/articles/articles2.svg",
    articlesThree: "shared/redesign/articles/articles3.svg",
    homeButtonGradientCallout:
      "old_mutual/homepage/gradient_button_callout.svg",
    homeGenericBackground: "old_mutual/homepage/generic.svg",
    homeCalculatorImage: require(`@/assets/shared/redesign/home/Home-Calculator.jpg`),
    homeTestatimonial1: "quickwill/homepage/pheboen.png",
    homeTestatimonial2: "quickwill/homepage/janis.png",
    homeTestatimonial3: "quickwill/homepage/chrismcleod.png",
    home1WhyChooseUsImage: require(`@/assets/shared/image-text-banner-images/Page1A.jpg`),
    home1JoinUsImage: require(`@/assets/shared/image-text-banner-images/Page1B.jpg`),
    home3DownloadbleTemplateImage: require(`@/assets/shared/image-text-banner-images/Page3B.jpg`),
    home2WeBelieveImage: require(`@/assets/shared/image-text-banner-images/Page2A.jpg`),
    home3thousandsImage: require(`@/assets/shared/image-text-banner-images/Page3A.jpg`),
    homeAbout1: "quickwill/homepage/stella_ceo.png",
    homeAbout2: "quickwill/homepage/FairbridgesLogo.png",
    overviewStep1: "quickwill/overview/about_yourself.svg",
    overviewStep2: "quickwill/overview/people.svg",
    overviewStep3: "quickwill/overview/assets.svg",
    overviewStep4: "quickwill/overview/sparkly_btc.svg",
    overviewStep5: "quickwill/overview/remainder1.svg",
    overviewStep6: "quickwill/overview/letter_of_wishes.svg",
    overviewStep7: "quickwill/overview/insurance.png",
    aboutYourselfPage: "quickwill/overview/about_yourself.svg",
    assetsPage: "quickwill/overview/remainder1.svg",
    worldWideAssetsPage: "quickwill/overview/remainder1.svg",
    pageNotFound: "quickwill/overview/pet_bostie.svg",
    productsCashAssist: "shared/insurance/cash_assist_icon.svg",
    productsDebtAssist: "shared/insurance/debt_assist_icon.svg",
    productsTaxAssist: "shared/insurance/tax_assist_icon.svg",
    productsEducationAssist: "shared/insurance/education_assist_icon.svg",
    productsEstateAssist: "shared/insurance/estate_assist_icon.svg",
    productsCostAssist: "shared/insurance/cost_assist_icon_new.svg",
    financialStrainIcon: "shared/insurance/financial_strain_icon.svg",
    delayedSupportIcon: "shared/insurance/delayed_support_icon.svg",
    propertySaleIcon: "shared/insurance/property_sale_icon.svg",
    customizedCostCalculation:
      "shared/insurance/customized_cost_calculation.svg",
    personalRecommendation: "shared/insurance/personal_recommendation.svg",
    insuranceAgeRestrictedPage: "quickwill/overview/charity_pig.svg",
    estimatedInsuranceRequiredPage:
      "quickwill/insurance/estimated-insurance-required.png",
    estimatedInsuranceRequiredInputPage:
      "quickwill/insurance/estimated-insurance-required-input.png",
    estimatedInsuranceRequiredOutputPage:
      "quickwill/insurance/estimated-insurance-required-output.png",
    getFreeInsuranceQuotePageTop:
      "quickwill/insurance/get-free-insurance-quote-page-top.svg",
    getFreeInsuranceQuotePageBottom:
      "quickwill/insurance/get-free-insurance-quote-page-bottom.svg",
    getFreeInsuranceQuotePageSmoker: "quickwill/insurance/smoker.svg",
    getFreeInsuranceQuotePageNonSmoker: "quickwill/insurance/non-smoker.svg",
    getFreeInsuranceQuotePageSmokerSelected:
      "quickwill/insurance/smoker-selected.svg",
    getFreeInsuranceQuotePageNonSmokerSelected:
      "quickwill/insurance/non-smoker-selected.svg",
    insuranceQuotes: "old_mutual/insurance/insurance-quotes.svg",
    insuranceQuotesCostAssist: "old_mutual/insurance/cost-assist.svg",
    insuranceQuotesCashAssist: "old_mutual/insurance/cash-assist.svg",
    insuranceQuotesDebtAssist: "old_mutual/insurance/debt-assist.svg",
    insuranceQuotesEduAssist: "old_mutual/insurance/edu-assist.svg",
    insuranceQuotesTaxAssist: "old_mutual/insurance/tax-assist.svg",
    insuranceBankingDetailsPage: "quickwill/insurance/banking-details.png",
    insuranceExplanationPage: "quickwill/insurance/explanation.png",
    insuranceQuestionsPage: "quickwill/insurance/questions.png",
    insuranceNonSACitizenPage: "quickwill/overview/charity_pig.svg",
    insuranceRequestAdvisorCallPage: "quickwill/insurance/explanation.png",
    insuranceEducationInfoIcon: "old_mutual/insurance/insurance-info-icon.svg",
    letterOfWishesPage: "quickwill/overview/letter_of_wishes.svg",
    livingWillPage: "quickwill/overview/living_will.png",
    manageAccountPage: "quickwill/overview/about_yourself.svg",
    peopleOverviewPage: "quickwill/overview/people.svg",
    peopleOverviewSpouse: "quickwill/overview/spouse.svg",
    peopleOverviewChildren: "quickwill/overview/guardian.svg",
    peopleOverviewExecutor: "quickwill/overview/executor.svg",
    peopleOverviewHeir: "quickwill/overview/heir.svg",
    peopleOverviewCharities: "quickwill/overview/charity_box.svg",
    peopleOverviewTrusts: "quickwill/overview/charity_pig.svg",
    distributionSpecificPercentageAlternativesPage:
      "quickwill/overview/remainder1.svg",
    assetDonationPage: "quickwill/overview/assets.svg",
    moneyDonationPage: "quickwill/overview/money_1.svg",
    specificDonationsPageAssets: "quickwill/overview/assets.svg",
    specificDonationsPageMoney: "quickwill/overview/money_1.svg",
    activateAccountPageMain:
      "quickwill/activation-landing-page/house_and_funeral.svg",
    activateAccountPage1: "quickwill/activation-landing-page/will.svg",
    activateAccountPage2: "quickwill/activation-landing-page/rand_money.svg",
    activateAccountPage3: "quickwill/activation-landing-page/tombstone.svg",
    activateAccountPage4: "quickwill/activation-landing-page/sold_house.svg",
    activateAccountPage5:
      "quickwill/activation-landing-page/will_being_read.svg",
    activateAccountPage6: "quickwill/activation-landing-page/executor.svg",
    executorExplainerMain: "quickwill/advisor-page/quinton.svg",
    executorExplainerHowDoesItWork1: "quickwill/executor/post_box.svg",
    executorExplainerHowDoesItWork2: "quickwill/executor/coffin.svg",
    executorExplainerHowDoesItWork3: "quickwill/executor/nomination_form.svg",
    executorExplainerHowDoesItWork4: "quickwill/executor/post_box_letter.svg",
    executorExplainerEstateAdminPartner: "quickwill/executor/ashmanslogo.png",
    advisorPageMain: "quickwill/advisor-page/quinton.svg",
    advisorPageWhyUseUs1: "quickwill/advisor-page/marketing_sharing.svg",
    advisorPageWhyUseUs2: "quickwill/advisor-page/bostie_and_leash.svg",
    advisorPageWhyUseUs3: "quickwill/advisor-page/scale.svg",
    advisorPageWhyUseUs4: "quickwill/advisor-page/executor.svg",
    advisorPageWhyUseUs5: "quickwill/advisor-page/dashboard.svg",
    howItWorksProcess: require(`@/assets/shared/redesign/how-it-works/HowItWorks-Process.jpg`),
    howItWorksProtectYourEstate: require(`@/assets/shared/redesign/how-it-works/HowItWorks-ProtectYourEstate.jpg`),
    howItWorksSafeStorage: require(`@/assets/shared/redesign/how-it-works/HowItWorks-SafeStorage.jpg`),
    howItWorksUpdateWill: require(`@/assets/shared/redesign/how-it-works/HowItWorks-UpdateWill.jpg`),
    ourSolutionsCashAssist: require(`@/assets/shared/redesign/our-solutions/Solutions-CashAssist.jpg`),
    ourSolutionsDebtAssist: require(`@/assets/shared/redesign/our-solutions/Solutions-DebtAssist.jpg`),
    ourSolutionsEduAssist: require(`@/assets/shared/redesign/our-solutions/Solutions-EduAssist.jpg`),
    ourSolutionsEstateAssist: require(`@/assets/shared/redesign/our-solutions/Solutions-EstateAssist.jpg`),
    ourSolutionsTaxAssist: require(`@/assets/shared/redesign/our-solutions/Solutions-TaxAssist.jpeg`),
    ourSolutionsEstatePlanningServices: require(`@/assets/shared/redesign/our-solutions/Solutions-EstatePlanningServices.jpg`),
    ourSolutionsOnlineWillCreation: require(`@/assets/shared/redesign/our-solutions/Solutions-OnlineWillCreation.jpg`),
    ourSolutionsEstateAdministration: require(`@/assets/shared/redesign/our-solutions/Solutions-EstateAdministration.jpg`),
    home1InfoTitleOne: "shared/info-tiles/Legal.svg",
    home1InfoTitleTwo: "shared/info-tiles/Experts.svg",
    home1InfoTitleThree: "shared/info-tiles/SouthAfricans.svg",
    home1InfoTitleFour: "shared/info-tiles/Rating.svg",
    home2InfoTitleOne: "shared/info-tiles/Online-icon.svg",
    home2InfoTitleTwo: "shared/info-tiles/Storage.svg",
    home2InfoTitleThree: "shared/info-tiles/Touch-screen.svg",
    home2InfoTitleFour: "shared/info-tiles/Support.svg",
    home3InfoTitleOne: "shared/info-tiles/Online-icon.svg",
    home3InfoTitleTwo: "shared/info-tiles/ValidateCheck.svg",
    home3InfoTitleThree: "shared/info-tiles/Legal.svg",
  },
  cssLogo: false,
  fontUrl:
    "https://fonts.googleapis.com/css?family=Nunito:100,300,400,500,700,900",
  fontFamily: `'Nunito', Helvetica, Arial, sans-serif`,
  homeUrl: "www.quickwill.co.za",
  pageTitle: "Create Your Will Online | Quick And Easy",
  getStartedBtnColor: "secondary",
  showTrustpilot: false,
  facebookPageUrl: null,
  linkedInPageUrl: null,
  contactAddress: null,
  contactAddressRedesign: null,
  contactTelNumber: null,
  contactEmail: null,
  showHomePageTestimonials: false,
  testimonialText1:
    "I made an appointment to see a lawyer but cancelled after I discovered QuickWill was less than a quarter of the price and I could do it straight away online, from my kitchen table!",
  testimonialName1: "Phebeon Vera",
  testimonialText2:
    "QuickWill offers a great service - when I had a question, I was able to speak to somebody immediately who gave clear, straightforward answers. It turned out to be Stella, QuickWill’s CEO! I felt I was in good hands.",
  testimonialName2: "Janis von Johannides",
  testimonialText3:
    "I have been thinking about drafting a will for ages but I had no idea where to start. QuickWill made it so easy to do online and I would highly recommend them.",
  testimonialName3: "Chris McLeod",
  showHomePageAbout: false,
  FAQUrl: null,
  blogUrl: null,
  showFinancialAdvisorExplainerPage: false,
  showExecutorExplainerPage: false,
  homeAboutTextBlurb1: `Our <strong> founder &amp; CEO, Stella Pickard</strong>, who is both a lawyer and a software developer, started QuickWill due to the fact that over 
    70% of South Africans pass on without a valid will in place, which causes unnecessary stress for their families who are left behind. With 
    QuickWill it is easy to create your own South African will online and you can do it from the convenience of your home, knowing the price upfront 
    - all while having our team help you with any questions you might face along the way.`,
  homeAboutTextBlurb2: `Fairbridges Wertheim Becker is our law firm partner, ensuring maximum trust and credibility for our customers in our product. They offer 
    various services to QuickWill clients. The firm was formed by the joining of two longstanding, respected law practices, the first being 
    Fairbridges established in 1812 in Cape Town, the second being Wertheim Becker founded in 1904 in Johannesburg. Their teams of experienced 
    and highly-qualified attorneys and professional staff allow Fairbridges to offer a wide-ranging service through their multi-disciplinary 
    practice.`,
  internalExecutorName: "Online Wills Estate Administrators",
  executorExplainerWhatDoesAnExecutorDoUrl:
    "http://support.quickwill.co.za/en/articles/3111475-what-does-my-executor-do-exactly",
  executorExplainerExperienceBlurb: `Stella Pickard, our CEO, is also a practicing lawyer with experience in administration of deceased estates.
    For that reason, she is capable of overseeing and managing our estate administration partners to ensure that only the highest quality
    service is provided and to minimise delays in the process.`,
  executorExplainerLargeVolumesBlurb: `QuickWill works with a network of law firm partners who have experience in administering deceased estates.
    We work closely with the team at Ashman attorneys, a boutique Cape Town based law firm to handle large volumes
    of estate administration cases at once.`,
  insurancePolicyName: "QuickWill Estate Plan",
  insuranceCallUsTel: "+27 11 084 7735",
  requestACallTel: "021 753 3248",
  requestACallTelUrl: "+27217533248",
  insuranceTermsPdfLocation: "pdfs/insurance_terms.pdf",
  eftPaymentAccountName: "Online Wills (Pty) Ltd",
  eftPaymentAccountNumber: "62811162544",
  eftPaymentBankName: "FNB",
  eftPaymentPopEmail: "hello@quickwill.co.za",
  cancelSubscriptionEmail: "cancel@quickwill.co.za",
  advisorPageGetInTouchEmail: "hello@quickwill.co.za",
  advisorPageShowPartnerLogos: false,
  loginPageMessage: null,
  homePagePopupMessage: null,
  showQWExecutorLinks: false,
  showTrustLearnMoreLink: false,
  authentication: {
    resetPassword: {
      title: "Enter the email you signed up with",
      fieldTitle: "Email",
      fieldName: "email",
      buttonText: "Request password reset email",
      validation: "required",
      validationMessage: "The email field is required.",
      successMessage:
        "If you signed up with this email address, you will receive an email to reset your password",
    },
    login: {
      title: "Log in",
      fieldTitle: "Email*",
      fieldName: "email",
      buttonText: "Log in",
      validation: "required|email",
    },
    signUp: {
      title: "Sign up to continue...",
      showEmail: true,
      showPhone: true,
      showUniqueIdentifier: false,
    },
    invite: {
      method: "email",
    },
  },
  showAdvisorAccessRequest: false,
  termsAndConditionsLocation: "/terms-and-conditions",
  estateAdministrationCostCalculator: {
    conveyancingFeesData: {
      tiers: [
        {
          tier: 1,
          minValue: 0,
          maxValue: 100000,
          baseFee: 6435,
          incrementalFee: 0,
          increment: null,
          incrementPoint: null,
        },
        {
          tier: 2,
          minValue: 100001,
          maxValue: 500000,
          baseFee: 6435,
          incrementalFee: 1025,
          increment: 50000,
          incrementPoint: 100000,
        },
        {
          tier: 3,
          minValue: 500001,
          maxValue: 1000000,
          baseFee: 14635,
          incrementalFee: 1985,
          increment: 100000,
          incrementPoint: 500000,
        },
        {
          tier: 4,
          minValue: 1000001,
          maxValue: 5000000,
          baseFee: 24560,
          incrementalFee: 1985,
          increment: 200000,
          incrementPoint: 1000000,
        },
        {
          tier: 5,
          minValue: 5000001,
          maxValue: Infinity,
          baseFee: 64260,
          incrementalFee: 5000,
          increment: 1000000,
          incrementPoint: 5000000,
        },
      ],
    },
  },
  sso: {
    googleSsoEnabled: false,
    googleClientId:
      "311768930697-alolgso3c0ip6n8npne6s30cf7vsknqg.apps.googleusercontent.com",
    facebookSsoEnabled: false,
    facebookAppId: "",
  },
  fbPixelId: "156740376237501",
  googleSiteVerificationCode: "4xeYWt7TXamrHdfOth2jQEA3H7JK-pYNKB3ISq6EvBE",
  developmentMeta: [
    { charset: "UTF-8" },
    { "http-equiv": "X-UA-Compatible", content: "IE=edge,chrome=1" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { name: "robots", content: "nofollow" },
    { name: "robots", content: "noindex" },
  ],
  howItWorksData: [
    {
      title: "The Process",
      titleHtml: "The Process",
      content: {
        image: require(`@/assets/shared/redesign/how-it-works/HowItWorks-Process.jpg`),
        text: `A will is a vital document that captures your last wishes. At Old Mutual, we guide you step-by-step through the process, ensuring you answer all the right questions.
         You’ll provide personal details, family information (such as spouse, children, and guardians), asset information, and list your beneficiaries.<br/><br/>
         Additionally, you can choose to:
        <br/><br/>
        <ul>
        <li>Set up testamentary trusts</li>
        <li>Make specific bequests</li>
        <li>Generate a Living Will</li>
        <li>Record a Letter of Wishes</li>
        </ul>
        <br />
        Old Mutual will be appointed as the professional executor of your estate, ensuring it’s settled efficiently and reducing the burden on your loved ones.
        <br /><br />
        We offer helpful information throughout the process, and expert support is available whenever you need it, via chat, phone or email.
        `,
      },
      subContent: {
        title: `<span style="font-weight:500">Easy</span><span style="font-weight:300"> updates</span>`,
        text: [
          "We know life doesn’t stay the same. That's why we've made it easy to update your will.",
          "Simply log in to your account and go to the section you want to update. Once you've made your changes, follow the steps above to get the new version into safe storage.",
        ],
        image: require(`@/assets/shared/redesign/common/placeholder.svg`),
        buttonText: "LOG IN",
        buttonUrl: "Login",
      },
    },
    {
      title: "Information You Need",
      titleHtml: "Information You Need",
      mobileTabbedContent: true,
      content: {
        image: null,
        text: [],
      },
      subContent: {
        title: `<span style="font-weight:500">Easy</span> updates`,
        text: [
          "We know life doesn’t stay the same. That's why we've made it easy to update your will.",
          "Simply log in to your account and go to the section you want to update. Once you've made your changes, follow the steps above to get the new version into safe storage.",
        ],
        image: require(`@/assets/shared/redesign/common/placeholder.svg`),
        buttonText: "LOG IN",
        buttonUrl: "Login",
      },
    },
    {
      title: "Protect Your Estate",
      titleHtml: `<span style="font-weight:500">Protect</span><span style="font-weight:300"> your Estate</span>`,
      content: {
        image: require(`@/assets/shared/redesign/how-it-works/HowItWorks-ProtectYourEstate.jpg`),
        text: `When you pass away, your loved ones will be required to settle costs related to winding up your estate.<br /><br /> As part of our process we provide you with a personalised 
          cost calculation and the option secure your estate through our EstateAssist product.<br /><br /> EstateAssist provides coverage for the cost such as executor fees,
           conveyancing fees, masters fees and standard administrative costs.`,
        buttonText: "CALCULATE MY COST NOW",
        buttonUrl: "EstateAdministrationCostCalculator",
      },
      subContent: {
        title: `<span style="font-weight:500">Easy</span> updates`,
        text: [
          "We know life doesn’t stay the same. That's why we've made it easy to update your will.",
          "Simply log in to your account and go to the section you want to update. Once you've made your changes, follow the steps above to get the new version into safe storage.",
        ],
        image: require(`@/assets/shared/redesign/common/placeholder.svg`),
        buttonText: "LOG IN",
        buttonUrl: "Login",
      },
    },
    {
      title: "Finalisation & Safe Storage",
      titleHtml: `<span style="font-weight:300">Finalisation &</span><span style="font-weight:500"> Safe Storage</span>`,
      content: {
        image: require(`@/assets/shared/redesign/how-it-works/HowItWorks-SafeStorage.jpg`),
        text: `After completing the process, download your will, print, and sign it by following the provided instructions. Then, upload the signed copy for expert verification.
        <br/>
        <br/>
        Once verified, we will collect your will free of charge and keep it in safe storage.
        `,
      },
      subContent: {
        title: `<span style="font-weight:500">Easy</span> updates`,
        text: [
          "We know life doesn’t stay the same. That's why we've made it easy to update your will.",
          "Simply log in to your account and go to the section you want to update. Once you've made your changes, follow the steps above to get the new version into safe storage.",
        ],
        image: require(`@/assets/shared/redesign/common/placeholder.svg`),
        buttonText: "LOG IN",
        buttonUrl: "Login",
      },
    },
  ],
  ourSolutionsData: [
    {
      title: `<span style="font-weight:700;color:#ED0080;text-decoration:underline;">Estate</span><span style="font-weight:500;color:#282828;">Assist</span>`,
      content: {
        image: require(`@/assets/shared/redesign/our-solutions/Solutions-EstateAssist.jpg`),
        text: `
          EstateAssist provides cover to manage the unexpected legal and administrative costs that arise after death, ensuring that your loved ones won’t have to sell assets to cover these expenses. 
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your needs.</li>
            <li>Covers executor fees, conveyancer fees, administration fees, and testamentary trust setup fees (if selected).</li>
            <li>Premiums are fixed for the first year, increasing by 6% annually thereafter.</li>
            <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.
            <li>Cover stops if payments are discontinued.</li>
            <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
        <strong>Get exclusive access to EstateAssist when you create your will through the Old Mutual online process.</strong>
        `,
        buttonText: "Create my will",
      },
    },
    {
      title: `<span style="font-weight:700;color:#E9AB21;text-decoration:underline;">Tax</span><span style="font-weight:500;color:#282828;">Assist</span>`,
      content: {
        image: require(`@/assets/shared/redesign/our-solutions/Solutions-TaxAssist.jpeg`),
        text: `
          TaxAssist is an additional benefit that can be added to your EstateAssist cover. It provides funds to settle outstanding taxes upon your death, preventing your family from needing to sell assets. 
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your tax requirements.</li>
            <li>Premiums are fixed for the first year, with a 6% annual increase afterward.</li>
            <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
            <li>Cover stops if payments are discontinued.
            <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
        <strong>You get exclusive access to the TaxAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        buttonText: "Create my will",
      },
    },
    {
      title: `<span style="font-weight:700;color:#6087ED;text-decoration:underline;">Edu</span><span style="font-weight:500;color:#282828;">Assist</span>`,
      content: {
        image: require(`@/assets/shared/redesign/our-solutions/Solutions-EduAssist.jpg`),
        text: `
          EduAssist is an additional benefit that can be added to your EstateAssist cover. 
          It ensures your children’s education continues without financial disruption if you pass away. 
         </br /></br />
     <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
         <li>Different levels of cover are offered depending on the requirements as relates to school-related expenses (fees, uniforms, stationery, transport).</li>
        <li>Payout is made each January to the nominated guardian or a testamentary trust until the child turns 18.</li>
        <li>Premiums remain stable for the first year, with a 6% annual increase thereafter.</li>
        <li>Available to parents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
             <strong>You get exclusive access to EduAssist when you create yo.ur will through the Old Mutual online process</strong>
        `,
        buttonText: "Create my will",
      },
    },
    {
      title: `<span style="font-weight:700;color:#8ABA3E;text-decoration:underline;">Cash</span><span style="font-weight:500;color:#282828;">Assist</span>`,
      content: {
        image: require(`@/assets/shared/redesign/our-solutions/Solutions-CashAssist.jpg`),
        text: `
        CashAssist is an additional benefit that can be added to your EstateAssist cover.  It offers immediate financial support to your family after your death, 
        ensuring they can manage daily expenses while your estate is settled. 
         </br /></br />
         <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
       <li>Different levels of cover are offered depending on your needs, typically offering enough for three months' worth of expenses.</li>
        <li>Payout is made within two weeks of submitting all required documents.</li>
        <li>Premiums are stable for the first year, with a 6% annual increase thereafter.</li>
        <li>Available to South African residents aged 18-65 with a valid SA ID number, that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
             <strong>You get exclusive access to the CashAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        buttonText: "Create my will",
      },
    },
    {
      title: `<span style="font-weight:700;color:#D65E23;text-decoration:underline;">Debt</span><span style="font-weight:500;color:#282828;">Assist</span>`,
      content: {
        image: require(`@/assets/shared/redesign/our-solutions/Solutions-DebtAssist.jpg`),
        text: `
      DebtAssist is an additional benefit that can be added to your EstateAssist cover. 
      It provides funds to settle outstanding debts upon your death, preventing your family from needing to sell assets. 
         </br /></br />
       <strong style="font-weight:600;font-size:16px;line-height:22px;">Key features include:</strong>
         <ul>
            <li>Different levels of cover are offered depending on your debt.</li>
        <li>Premiums are fixed for the first year, with a 6% annual increase afterward.</li>
        <li>Available to South African residents aged 18-65 with a valid SA ID number, 
          that meet the requirements of our simplified underwriting process.</li>
        <li>Cover stops if payments are discontinued.</li>
        <li>Does not cover suicide.</li>
        </ul>
        <br /></br />
        <strong>You get exclusive access to the DebtAssist benefit when you create your will through the Old Mutual online process.</strong>
        `,
        buttonText: "Create my will",
      },
    },
  ],
  socialMedia: [
    {
      imageUrl: require(`@/assets/shared/redesign/icons/facebook.svg`),
      mediaUrl: "https://www.facebook.com/OldMutualSA",
    },
    {
      imageUrl: require(`@/assets/shared/redesign/icons/x.svg`),
      mediaUrl: "https://x.com/OldMutualltd",
    },
    {
      imageUrl: require(`@/assets/shared/redesign/icons/linkedin.svg`),
      mediaUrl: "https://linkedin.com/company/old-mutual",
    },
    // {
    //   imageUrl: require(`@/assets/shared/redesign/icons/whatsapp.svg`),
    //   mediaUrl: "",
    // },
    // {
    //   imageUrl: require(`@/assets/shared/redesign/icons/youtube.svg`),
    //   mediaUrl: "",
    // },
    // {
    //   imageUrl: require(`@/assets/shared/redesign/icons/instagram.svg`),
    //   mediaUrl: "",
    // },
  ],
  FAQs: [
    {
      title: "<h2>What is a will and why do you need one?</h2>",
      content: `<p>A will is a legal document that states what you want to happen to everything you own when you pass 
      away, e.g., properties, car, money, investments. If you have children under the age of 18, 
      a will allows you to say who you would like their legal guardians to be.
       Your will also stipulates your burial preferences.</p>
        <p>A will ensures that your final wishes are clearly articulated, to be carried by an executor.</p>`,
    },
    {
      title:
        "<h2>Why do I need a will and what happens if I pass away without one?</h2>",
      content: `<p>When you die without a will, your estate will be subject to the laws of intestate succession, which may not align with your personal preferences or 
      the specific needs of your loved ones.</p>
      <p>Practically, this means that your belongings will be divided to your surviving family members according to a set formula, 
      and provisions for minor children will be placed in the Guardians Fund making it less accessible to be used for their immediate needs.</p>`,
    },
    {
      title: "<h2>Why should I use Old Mutual?</h2>",
      content: `<p>At Old Mutual, we've combined the convenience, cost-effectiveness, ease of use, accessibility, privacy, and customisation features of an online platform
       with the legal compliance of will drafting to bring you a truly accessible, digital will at no charge.</p>
         <p>By completing our straightforward process you will have a legally binding will, ready to be printed and signed.</p>`,
    },
    {
      title: "<h2>What information do I need to complete my Will?</h2>",
      content: `<img class="accordion-image" src="${require("@/assets/shared/redesign/faqs/faq2.png")}" />`,
    },
    {
      title: "<h2>How to sign your Will</h2>",
      content: `<ol>
        <li>Print out two copies of your Last Will and Testament.</li>
         <li>Sign each page of your Will in full at the bottom of the page where it says, Testator/Testatrix____________.</li>
        <li>Get two witnesses to sign each page of your Will in full at the bottom of 
            the page, where it says “As Witnesses”. 
            It is very important that the people who sign as your witnesses 
            are not getting any money or assets; they are guardians, executors, 
            or trustees in your Will. If they are, and they sign, they will no 
            longer be able to inherit or undertake their mandated functions.</li>
            <img class="accordion-image" src="${require("@/assets/shared/redesign/faqs/faq3.png")}" />
        <li>You must add the place or location the Will has been signed, along with the day and month on the last page of the Will.</li>
        <li>Your two witnesses must add their full name, ID number, address, contact number, and their relationship to you on the last page of your Will.</li>
        <li>Ensure that you sign the Will at the same place and time as your witnesses.</li>
        </ol>
             <img class="accordion-image" src="${require("@/assets/shared/redesign/faqs/faq4.png")}" />
      <p>Once you have signed your Will correctly, please upload the signed copy on the Will Verification page of our platform. 
      Our fiduciary team will check to make sure you have signed it correctly.</p>
           <img class="accordion-image" src="${require("@/assets/shared/redesign/faqs/faq1.png")}" />
      `,
    },
    {
      title: "<h2>What is the benefit of Old Mutual as my Executor?</h2>",
      content: `<p>As part of our offering, Old Mutual will act as your appointed executor. 
      Old Mutual as your Executor ensures that your estate is managed by experienced professionals who handle all legal, financial, and administrative 
      tasks with expertise and care. This minimises delays, reduces the risk of errors, and guarantees that your wishes are fulfilled efficiently and in accordance 
      with the law.</p>
      <p>It’s important to know that all executors, including Old Mutual, are entitled to a legislated executor fee. 
      This fee is typically 3.5% of the gross value of your estate, excluding VAT.</p>
`,
    },
    {
      title: "<h2>How often should I update my will?</h2>",
      content: `<p>It’s a good idea to review and update your will whenever there are significant life events such as marriage, divorce, 
      birth of children or grandchildren, or acquisition of new assets. It’s also a good idea to review your will periodically to ensure it still reflects your wishes.</p>`,
    },
    {
      title: "<h2>What assets should I include in my will?</h2>",
      content: `<p>You should include all significant assets in your will, such as real estate, bank accounts, investments, vehicles, 
      valuable personal property, and sentimental items. Certain assets may pass outside of the will, such as life insurance policies with 
      their own nominated beneficiaries, retirement accounts with designated beneficiaries, tribal land, and jointly owned property with rights of survivorship.</p>`,
    },
    {
      title: "<h2>Can I change my will after it’s been drafted?</h2>",
      content: `<p>At Old Mutual, you can update or amend your will at any time and at no cost. 
      It is important to follow the same signature guidelines after any changes to ensure your will is valid.</p>`,
    },
    {
      title: "<h2>How much does it cost to draft a will?</h2>",
      content: `<p>Traditionally the cost of drafting a will can vary. Old Mutual’s online will drafting service is however offered free of charge.</p>`,
    },
    {
      title: "<h2>The cost of dying</h2>",
      content: `<p>No matter who you are, dying costs money. There are certain unavoidable legal and administrative fees associated to passing away.</p>
        <h2>Executor fees</h2>
        <p>Executors may charge a fee for their services and assistance in administering a deceased estate. 
        These fees are legislated and apply across the board. Executors can charge up to 3.5% on the gross value of an estate and 6% on any income generating from the estate. 
        These fees are exclusive of VAT.</p>
        <h2>Conveyancing fees</h2>
        <p>Fees and taxes payable when a property is being transferred from one person (or their estate) to another. 
        This does not include the outstanding amount on any mortgage that may be applicable.</p>
        <h2>Master’s fees</h2>
        <p>Fees payable to the Master’s Office pertaining to the administration of a deceased estate.</p>
        <h2>Standard administrative costs</h2>
        <p>Fees towards paying for costs of advertising notices in newspapers regarding the deceased estate.</p>
        <h2>Testamentary Trust Fees</h2>
        <p>A testamentary trust, set up by a will, safeguards assets for beneficiaries like minor children but involves costs, including trustee fees (0.5%-2% annually), 
        legal, and administrative expenses, which can accumulate over time. Proper planning helps maximise benefits while managing these costs.</p>
        <h2>Unsettled debts</h2>
        <p>Upon death, any outstanding debts of the deceased must be settled, including credit card balances, loans, mortgages, and medical bills.</p>
        <h2>Estate duty</h2>
        <p>Inheritance tax or estate tax is a tax imposed on the transfer of assets from a deceased person’s estate to their heirs or beneficiaries.</p>
        <h2>Transfer Duty</h2>
        <p>Transfer duty is a tax paid on the transfer of property ownership from a deceased estate to a beneficiary, adding to the costs involved in settling the estate along with legal, 
        administrative, and executor fees.</p>
        `,
    },
  ],
  FAQs1: [
    {
      title: "<h2>Is this really free?</h2>",
      content: `<p style="font-weight:700;">Yes - creating your will with Old Mutual Will is completely free.</p> 
      <p>There are no hidden fees to create, validate, or store your will. You can update it as often as needed at no cost. As part of the process, Old Mutual will be appointed as your executor to ensure your wishes are professionally carried out when the time comes.</p>`,
    },
    {
      title: "<h2>Is it legally valid?</h2>",
      content: `<p style="font-weight:700;">Yes - your will is legally valid in South Africa.</p>
      <p>Our step-by-step process helps you create a compliant will that can be printed and signed to meet legal requirements. Once signed, our experts will review it to ensure it meets all formalities - so you can have peace of mind.</p>`,
    },
    {
      title: "<h2>What if I need to update it?</h2>",
      content: `<p style="font-weight:700;">You can update your will anytime, for free.</p>
      <p>Life changes - and your will should reflect that. Simply log in, make your changes, and reprint your updated version. We’ll walk you through every step.</p>`,
    },
    {
      title: "<h2>Do I need a lawyer?</h2>",
      content: `<p style="font-weight:700;">No lawyer is needed.
      <p>Our process is designed to be simple and legally sound - without the jargon. Prefer personal support? You can always speak to your Old Mutual adviser or broker.</p>`,
    },
    {
      title: "<h2>Is my information safe?</h2>",
      content: `<p style="font-weight:700;">Yes - your information is secure and confidential.</p>
      <p>We use bank-grade encryption and follow strict data protection protocols. Your personal details are never shared without your permission. Your privacy and trust matter to us.</p>`,
    },
  ],
  FAQs2: [
    {
      title: "<h2>Is this really free?</h2>",
      content: `<p>Yes - there are no costs to create, validate or store your will. Old Mutual only charges a standard executor fee (3.5% excluding VAT of the gross value of the estate, plus 6% excluding VAT of any income generated by the estate during the estate administration process) to help your loved ones manage your estate after your passing.</p>`,
    },
    {
      title: "<h2>Do I have to appoint Old Mutual as Executor?</h2>",
      content: `<p>Yes - it’s part of what enables us to offer the will service at no charge, while ensuring your estate is professionally executed, eliminating that burden for your loved ones.</p>`,
    },
    {
      title: "<h2>Is the executor fee standard?</h2>",
      content: `<p>Yes - 3.5% (excluding VAT) of the gross value of the estate, plus 6% (excluding VAT) of any income generated by the estate during the estate administration process is the regulated executor fee in South Africa. Any executor of your estate will be entitled to this fee.</p>`,
    },
    {
      title: "<h2>Can I update my will later?</h2>",
      content: `<p>Absolutely, we don’t charge for updates, which means it’s easy to keep your will updated with your wishes, even when life changes.</p>`,
    },
  ],
  FAQs3: [
    {
      title: "<h2>Can I download a will template?</h2>",
      content: `<p>We don’t offer static templates. Our free online service creates a legally compliant will tailored to your needs - faster, safer, and easier.</p>`,
    },
    {
      title: "<h2>Do I need legal knowledge?</h2>",
      content: `<p>No. Our guided process uses plain language and handles the legal structure for you. We also provide helpful information at every step of the process, and our trained support staff is always just a call away.</p>`,
    },
    {
      title: "<h2>Can I update my will later?</h2>",
      content: `<p>Absolutely, we don’t charge for updates, which means it’s easy to keep your will aligned with your wishes, even when life changes.</p>`,
    },
    {
      title: "<h2>Is my information secure?</h2>",
      content: `<p>Yes - your data is encrypted, stored in South Africa, and never shared without your consent.</p>`,
    },
  ],
  videos: {
    childrensGuardianVideo: "https://youtube.com/embed/TLw-umQcWS8?rel=0",
    testamentaryTrustVideo: "https://youtube.com/embed/OaVhkFQIHFk?rel=0",
    executorVideo: "https://youtube.com/embed/K7V52lWQxOQ?rel=0",
    livingWillVideo: "https://youtube.com/embed/7olMrlgM6x4?rel=0",
    maritalRegimeVideo: "https://youtube.com/embed/eY6hWOyfqRk?rel=0",
    inheritanceChoicesVideo: "https://youtube.com/embed/ymY3BOUiBis?rel=0",
  },
  childrensGuardianData: [
    {
      title: "<h2>Why You Need to Appoint a Legal Guardian</h2>",
      content: `<p>Appointing a legal guardian ensures that your child is cared for 
      by someone you trust if you pass away. Without a guardian named in your will, 
      the court may decide who will care for your child, leading to potential stress 
      and conflict for your family.</p>`,
    },
    {
      title: "<h2>How to Legally Appoint a Guardian in South Africa</h2>",
      content: `<p>To appoint a guardian, specify the person or persons in your will. This must be submitted to the High Court 
      with a note from the Family Advocate in the event of your passing.
       The court will honour your choice if it aligns with your child’s best interests.</p>`,
    },
    {
      title: "<h2>Key Factors When Choosing a Guardian</h2>",
      content: `<p>Consider the guardian's location, stability, values, relationship with your child, and their willingness to take on this role. 
      These factors ensure that your child's well-being and upbringing are in safe hands.</p>`,
    },
    {
      title: "<h2>Difference Between a Legal Guardian and a Godparent</h2>",
      content: `<p>A legal guardian takes full responsibility for your child’s care, including financial and educational decisions. 
      A godparent has a spiritual role and no legal obligations or rights regarding your child.</p>`,
    },
    {
      title: "<h2>The Importance of Naming a Secondary Guardian</h2>",
      content: `<p>It’s wise to appoint a secondary guardian in case the primary guardian cannot fulfil their role. 
      This provides an alternative to ensure your child is cared for without delay.</p>`,
    },
    {
      title:
        "<h2>Managing Your Child’s Inheritance with a Testamentary Trust</h2>",
      content: `<p>Minors cannot receive an inheritance directly in South Africa. A testamentary trust allows you to 
      manage how your child’s inheritance is handled, protecting their financial future and preventing potential conflicts of interest.</p>`,
    },
    {
      title: "<h2>What Happens If You Don’t Appoint a Guardian?</h2>",
      content: `<p>If no guardian is appointed, the court will decide who cares for your child, which may lead to a 
      prolonged legal process and family disputes, adding stress during an already difficult time.</p>`,
    },
    {
      title: "<h2>Changing the Appointed Guardian in Your Will</h2>",
      content: `<p>You can change the appointed guardian at any time by updating your will. 
      Ensure that the changes comply with South African legal requirements to be valid.</p>`,
    },
  ],
  maritalRegimeData: [
    {
      title: "<h2>How Your Marital Regime Influences Estate Distribution</h2>",
      content: `<p>Your marital regime—whether in community of property, out of community with accrual, or out of 
      community without accrual—affects how your estate can be distributed and taxed. Each 
      regime has different implications for estate duty, Capital Gains Tax  (CGT), and what 
      portion of the combined estate you can bequeath to others.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: In Community of Property – The Value of Your Estate</h2>",
      content: `<p>With in community of property regimes, spouses share assets and debts equally.
       Your spouse automatically inherits 50% of the estate, and estate duty applies only to your half. 
       General and spousal abatements can further reduce the taxable portion.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: Out of Community of Property with Accrual – Spousal Claims and Abatements</h2>",
      content: `<p>In this regime, each spouse owns their assets, but any growth in value is shared. Your spouse has a claim on your estate for any growth difference, and this value is exempt from estate duty. 
      In addition, the spousal abatement can be applied to reduce taxes on the remainder.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: Out of Community of Property Without Accrual: The Value of Your Estate</h2>",
      content: `<p>This regime allows each spouse to retain full ownership of their assets, offering more freedom in bequeathing assets. However, 
      this can lead to higher estate duty and CGT, as there’s no spousal transfer to defer taxes.</p>`,
    },
    // {
    //   title:
    //     "<h2>Marital Regime: Out of Community of Property Without Accrual: The Value of Your Estate</h2>",
    //   content: `<p>This regime allows each spouse to retain full ownership of their assets, offering more freedom in bequeathing assets. However,
    //   this can lead to higher estate duty and CGT, as there’s no spousal transfer to defer taxes.</p>`,
    // },
    // {
    //   title: "<h2>How Inheritance Choices Impact Estate Taxes</h2>",
    //   content: `<p>Deciding who inherits your assets affects the taxes and duties payable by your estate. Understanding these implications
    //   helps you minimise the financial burden on your loved ones and ensure your wishes are fulfilled.</p>`,
    // },
    // {
    //   title: "<h2>Understanding Estate Duty and Available Abatements</h2>",
    //   content: `<p>Estate duty is a tax payable to the South African Revenue Service on the net value of your estate (dutiable estate).
    //   Estates with a dutiable estate of less than R3.5 million is exempt from estate duty, also called an abatement.  If the full abatement of
    //   is not used by the estate of a deceased, this can roll over to the surviving spouse.  This can significantly reduce estate duty payable by the
    //   overall estate.</p>`,
    // },
    // {
    //   title: "<h2>Capital Gains Tax (CGT) Considerations</h2>",
    //   content: `<p>Upon death, your assets are treated as if sold at market value, triggering CGT. However, exclusions like the primary
    //   residence exemption, spousal rollover relief, and small business exclusions can reduce this liability, preserving more of your estate
    //   for your beneficiaries.</p>`,
    // },
    // {
    //   title: "<h2>Permissible Deductions to Reduce Taxable Estate Value</h2>",
    //   content: `<p>Certain deductions, such as funeral expenses, outstanding debts, and bequests to a spouse or charity,
    //   can lower the taxable value of your estate. These deductions are essential for reducing estate duty and ensuring that more assets go to your beneficiaries.</p>`,
    // },
  ],
  inheritanceChoicesData: [
    {
      title: "<h2>How Inheritance Choices Impact Estate Taxes</h2>",
      content: `<p>Deciding who inherits your assets affects the taxes and duties payable by your estate. 
      Understanding these implications helps you minimise the financial burden on your loved ones and ensure your wishes are fulfilled.</p>`,
    },
    {
      title:
        "<h2>Leaving Assets To Your Spouse May Lower The Taxable Value Of Your Estate</h2>",
      content: `<p>Certain deductions, such as funeral expenses, outstanding debts, and bequests to a spouse or charity, can lower the taxable value of your estate. 
      These deductions are essential for reducing estate duty and ensuring that more assets go to your beneficiaries.</p>`,
    },
    {
      title:
        "<h2>Unused Estate Duty Abatements May Roll Over to Your Spouse</h2>",
      content: `<p>Estate duty is a tax payable to the South African Revenue Service on the net value of your estate (dutiable estate). Estates with a dutiable estate of less than R3.5 million are exempt from estate duty, also called an abatement.  If the full abatement is not used by the estate of a deceased, this can roll over to the surviving spouse. 
      This can significantly reduce estate duty payable by the overall estate.</p>`,
    },
    {
      title:
        "<h2>Leaving An Asset To Your Spouse May Be Beneficial For Capital Gains Tax (CGT)</h2>",
      content: `<p>Upon death, your assets are treated as if sold at market value, triggering CGT. However, 
      exclusions like the primary residence exemption, spousal rollover relief, and small business exclusions can reduce this 
      liability, preserving more of your estate for your beneficiaries.</p>`,
    },
    {
      title:
        "<h2>How Your Marital Regime Influences Estate Distribution and Taxes</h2>",
      content: `<p>Your marital regime, whether in community of property, out of community of property with accrual, or out of community of property without accrual, affects how your estate can be distributed and taxed. Each regime has different implications for estate duty, Capital Gains Tax (CGT), 
      and what portion of the combined estate you can bequeath to others.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: In Community of Property – The Value of Your Estate</h2>",
      content: `<p>With in community of property regimes, spouses share assets and debts equally. Your spouse automatically inherits 50% of the estate, and estate duty applies only to your half. 
      General and spousal abatements can further reduce the taxable portion.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: Out of Community of Property with Accrual – Spousal Claims and Abatements</h2>",
      content: `<p>In this regime, each spouse owns their assets, but any growth in value is shared. 
      Your spouse’s claim on your estate for any growth difference is exempt from estate duty, and the spousal abatement can be applied to reduce taxes on the remainder.</p>`,
    },
    {
      title:
        "<h2>Marital Regime: Out of Community of Property Without Accrual: The Value of Your Estate</h2>",
      content: `<p>This regime allows each spouse to retain full ownership of their assets, offering more freedom in bequeathing assets. However, this can lead to 
      higher estate duty and CGT, as there’s no spousal transfer to defer taxes.</p>`,
    },
    {
      title: "<h2>Maintenance Claims by Surviving Spouse</h2>",
      content: `<p>Regardless of your marital regime, your spouse can claim maintenance from your estate if they cannot meet their reasonable needs.
       This claim takes precedence over other bequests, potentially reducing what is available to your heirs.</p>`,
    },
  ],

  articleTiles: [
    {
      id: 1,
      date: "May 20, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/EstatePlanning.jpg"),
      title: "Estate Planning",
      description:
        "Estate Liquidity - The Importance of Protecting Your Estate",
      buttonText: "Read More",
    },
    {
      id: 2,
      date: "Apr 23, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/articles2.svg"),
      title: "Wills",
      description: "Appointing A Guardian In Your Will - A Comprehensive Guide",
      buttonText: "Read More",
    },
    {
      id: 3,
      date: "Apr 23, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/articles3.svg"),
      title: "Wills",
      description: "Divorce and Wills - What You Need To Know",
      buttonText: "Read More",
    },
    {
      id: 4,
      date: "Apr 16, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/articles4.jpg"),
      title: "Executor",
      description: "Executor of Will - Why Do You Need A Professional Executor",
      buttonText: "Read More",
    },
    {
      id: 5,
      date: "Apr 16, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/articles5.jpg"),
      title: "Wills",
      description:
        "Wills in South Africa - 70% of South Africans Die Without a Will",
      buttonText: "Read More",
    },
    //NEW ARTICLES
    {
      id: 6,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image5.jpg"),
      title: "Estate Planning",
      description:
        "Understanding Testamentary Trusts and Their Role in Estate Planning",
      buttonText: "Read More",
    },
    {
      id: 7,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image17.jpg"),
      title: "Wills",
      description:
        "Why You Need a Last Will and Testament: A Comprehensive Guide",
      buttonText: "Read More",
    },
    {
      id: 8,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image18.jpg"),
      title: "Wills",
      description:
        "Step-by-Step Guide to Writing a Last Will and Testament with Old Mutual Online Wills",
      buttonText: "Read More",
    },
    {
      id: 9,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image8.jpg"),
      title: "Wills",
      description:
        "Free Will Templates: What You Need to Know Before You Use One",
      buttonText: "Read More",
    },
    {
      id: 10,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image19.jpg"),
      title: "Estate Planning",
      description:
        "Estate Planning: The Key to Protecting Your Legacy and Your Loved Ones",
      buttonText: "Read More",
    },
    {
      id: 11,
      date: "Oct 29, 2024",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image16.jpg"),
      title: "Wills",
      description:
        "A Complete Guide to Living Wills and How You Can Create One with Old Mutual’s Online Will Service",
      buttonText: "Read More",
    },
    //NEW NEW ARTICLES
    {
      id: 12,
      date: "Mar 10, 2025",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image20.jpg"),
      title: "Estate Planning",
      description:
        "Understanding the significance of marital regimes in estate planning",
      buttonText: "Read More",
    },
    {
      id: 13,
      date: "Mar 10, 2025",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image21.jpg"),
      title: "Estate Planning",
      description:
        "Understanding Estate Duty and Related Taxes in South Africa",
      buttonText: "Read More",
    },
    {
      id: 14,
      date: "Mar 10, 2025",
      imageUrl: require("@/assets/shared/redesign/articles/Article-image22.jpg"),
      title: "Estate Planning",
      description:
        "Understanding the implications of debt settlement after death",
      buttonText: "Read More",
    },
  ],
  articles: [
    //title: "Estate Liquidity - The Importance of Protecting Your Estate"
    {
      id: 1,
      category: "Estate Planning",
      date: "May 20, 2024",
      route: "estate-liquidity-the-importance-of-protecting-your-estate",
      // title: "Estate Liquidity - The Importance of Protecting Your Estate",
      description: `Whenever the subject of <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link"> estate planning</a> pops up in conversation, it is easy to get caught up in 
      all the big terms and catchy phrases. One is rarely reminded of the importance of ensuring that your estate is liquid 
      and able to afford the expenses related to winding up the estate.`,
      imageUrl: require("@/assets/shared/redesign/articles/EstatePlanning.jpg"),
      pathName: "Estate Liquidity - The Importance of Protecting Your Estate",
      heroTitle: "Estate Liquidity - The Importance of Protecting Your Estate",
      heroDescription:
        "Plan ahead to ensure there is enough money to manage and settle an estate",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Create Your Will Online | Articles",
      metaDescription:
        "Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.",
      content: [
        `<h2 class="mt-0">Solvency vs Liquidity</h2>`,
        `<p>Effective and purposeful <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a> most 
        often centres around the solvency of an estate: whether the total value of the assets exceeds that of the total liabilities. Although solvency 
        is without doubt the most important consideration in <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a>, it is by no means the only important factor to consider.</p>`,
        `<p>Just because the value of an estate’s assets exceeds that of its liabilities does not necessarily mean that the process of winding up is 
        guaranteed to be as expeditious and (relatively) simple as one would prefer.</p>`,
        `<p>It is important that there is enough cash in the estate to cover the administrative expenses and claims against the estate. 
        A lot of the assets in an estate can be immovable property, financial assets and shares – assets that are 
        generally harder to liquidate and reduce to cash.</p>`,
        `<blockquote>Ensuring estate liquidity is crucial for covering administrative expenses and claims during the winding-up process. 
        While solvency is important, having enough cash to manage costs is equally vital, as many estate assets 
        can be difficult to liquidate.</blockquote>`,
        `<h2>Why is liquidity important?</h2>`,
        `<p>When the liquidation and distribution account is drafted, the executor (or agent) needs to draft a "cash recapitulation statement" as well. 
        This is to determine the liquidity of the estate. The executor (or agent) needs to set out the cash assets, liabilities, legacies and estate duty.
         This is to show the Master’s Office that the estate is liquid.</p>`,
        `<p>In the process of winding up the deceased estate, there are certain amounts that need to be paid out of the estate – 
        these include the various administration costs, fees and other expenses that must be incurred when winding up the estate.</p>`,
        `<blockquote>When creating the liquidation and distribution account, the executor needs to prepare a “cash recapitulation statement” 
        to check the estate's liquidity. This involves listing cash assets, debts, legacies, and estate duty to show the Master’s 
        Office that the estate can cover its expenses. Various administration costs and fees need to be paid during the winding-up process, 
        depending on the estate's size. </blockquote>`,
        `<p>The relevant estate administration cost and fees include the following but can vary in value based on the size of that particular estate:</p>`,
        `<h2>Master’s fees (payable to the Master of the High Court)</h2>`,
        `<p>Estates with a nett value between R250 000.00 to R400 000.00 will incur a fee of R600.00, the minimum payable to the Master of the High Court.</p>`,
        `<p>An additional R200.00 for every R100 000.00 above R400 000.00 up until a maximum of R7 000.00 also apply.</p>`,
        `<h2>Executor’s fees and administration costs</h2>`,
        `<p>A maximum of 3.5% (plus VAT) of the gross total asset value of the estate can be asked by the <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> of an estate for the winding-up of a deceased’s estate.</p>`,
        `<p>A maximum of 6% of all the income earned by the estate while being administered by the <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> can also be payable to the executor;</p>`,
        `<h2>Fees for valuations and appraisals</h2>`,
        `<p>Based on the value of the property, the proposed basic tariff for property valuations operates on a sliding 
        scale and starts at R500.00 for a property with a value up to R50 000.00.</p>`,
        `<p>For all properties with a value of more than R50 000.00, the proposed basic tariff increases along 
        with an additional tariff that applies for every additional R100 000.00 in the property’s value – an 
        expense any estate with immovable property has to incur as valuations are required for the transfer of immovable property.</p>`,
        `<h2>Conveyancing and transfer fees</h2>`,
        `<p>Where immovable property is involved, one would need the professional help of a conveyancer or 
        conveyancing attorney. Although these professionals are likely to charge their own 
        fees (and these being dependent on the value of the property being transferred from the deceased’s 
        estate to his / her heir), one generally needs cash to pay these accounts and cannot rely on the value of a property to provide for this.</p>`,
        `<h2>Estate duty</h2>`,
        `<p>Estate duty is calculated at 20% of the nett value of an estate. That is, 20% of what is left after all the liabilities have been deducted from the value of the assets. As is evident, this is by far the largest part that will have to be paid by the estate and can have a big impact on what loved ones eventually inherit.</p>`,
        `<h2>Income tax and capital gains tax</h2>`,
        `<p>Capital gains tax forms part of the income tax of the deceased. It is ‘as if’ the deceased sells all of his/her assets upon his/her death.</p>`,
        `<CreateYourWillBanner bannerText="Protect your family's future" />`,
        `<h2>Consequences if the estate is not liquid?</h2>`,
        `<blockquote>If an estate lacks liquidity, the executor may need to sell assets like vehicles 
        or the family home, potentially at prices below market value. This can delay the winding-up process and cause 
        financial strain on heirs. Naming your estate as the beneficiary of a life insurance policy or taking out specific 
        insurance for estate administration costs can provide the necessary funds to avoid these issues.</blockquote>`,
        `<p>Failing to ensure that your estate is able to pay for all the costs in administering and winding up thereof is often the reason for long delays in the process. Not only would the executor need more time to be able to sell certain assets, but the sale of properties and vehicles generally entails rigorous administration and could possibly incur more costs.</p>`,
        `<p>The executor might also be forced to sell these assets at prices that are well below their market value (not to mention their sentimental value) and for less cash than one would have received for them should it have been a planned sale.</p>`,
        `<p>For example, the executor might need to sell a vehicle or even the family home if the estate does not have enough cash to pay for the expenses relating to the winding-up of the estate. Alternatively, the heirs may choose to pay the cash shortfall themselves to ensure that the assets are not sold. Either way, this is not an ideal situation and one which could be avoided through comprehensive estate planning.</p>`,
        `<p>One possible option to consider which would provide necessary liquidity for the winding up of your estate is naming your estate as the beneficiary of a life insurance policy. In doing so, your life insurance benefit will be paid directly into the bank account of your estate and could cover the necessary expenses that will have to be incurred, while safeguarding your loved ones against having to wait for much-needed closure in already stressful times.</p>`,
        `<p>Another possible solution is to take out specific insurance in relation to the administration costs. You are able to calculate your liquidity and determine more or less the cash amount needed for your estate upon your death. The insurance will then pay out the insured amount on your death and this will ensure that it is far less likely that your assets would have to be sold or that your loved ones would have to pay ‘into’ the estate to cover any shortfall.</p>`,
        `<p>Albert Einstein famously said “nothing is certain except for death and taxes”. Perhaps a more accurate statement would be: nothing 
        is certain except for death, the high cost of winding-up estates and taxes.</p>`,
        `<p>As part of our online will creation process, Old Mutual Will provides you with the opportunity to <a href="/estate-administration-cost-calculator" class="article-link">calculate the costs</a> related 
        to winding up your estate as well as the opportunity to purchase our EstateAssist range of products. 
        Estate Assist provide protection against the various costs related to winding up your estate.</p>`,
        `<p class="om-green"><a href="/register">Create your will</a> today and protect what matters most with our trusted, expert-backed process.</p>`,
      ],
    },
    //   title: "Appointing A Guardian In Your Will - What You Need to Know"
    {
      id: 2,
      category: "Wills",
      date: "Apr 23, 2024",
      route: "appointing-a-guardian-in-your-will-a-comprehensive-guide",
      // title: "Appointing a Guardian in Your Will – A Comprehensive Guide",
      description: `Appointing a legal guardian for your child is one of the most important decisions 
      you will make when drafting a will. It ensures that your child is cared for by someone you trust should 
      anything happen to you. This guide will walk you through everything you need to know about appointing a 
      guardian in South Africa.`,
      imageUrl: require("@/assets/shared/redesign/articles/articles2.svg"),
      pathName: "Appointing A Guardian In Your Will",
      heroTitle: "Appointing a Guardian in Your Will – A Comprehensive Guide",
      heroDescription:
        "How to choose the best guardian for your child's future.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Create Your Will Online | Articles",
      metaDescription:
        "Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.",
      content: [
        `<h2 class="mt-0">The Role of a Guardian</h2>`,
        `<p>A guardian plays a crucial role in a child's life, providing not only a home but also emotional, financial, 
        and educational support. They take on the responsibilities of a parent, making key decisions about healthcare, 
        schooling, and daily needs. The ideal guardian ensures a stable and nurturing environment, offering protection 
        and guidance until the child reaches adulthood.</p>`,
        `<blockquote>Secure your child’s future by choosing a guardian who aligns with your values, provides stability, 
        and will ensure their well-being.</blockquote>`,
        `<h2 class="mt-0">Why Appointing a Guardian is Essential</h2>`,
        `<p>If you pass away without appointing a guardian, the court will determine who will care for your child. 
        This process can be time-consuming, stressful for surviving family members, and may result in a guardian who 
        does not align with your parenting values. By legally appointing a guardian, you:</p>`,
        `<ul>
        <li>Ensure your child is cared for by someone you trust.</li>
        <li>Minimise the risk of family disputes.</li>
        <li>Provide clarity and security for your child’s future.</li>
        <li>Prevent delays in legal proceedings that could impact your child’s well-being.</li>
        </ul>`,
        `<h2 class="mt-0">How to Appoint a Guardian in Your Will</h2>`,
        `<ol>
        <li>Choose the Right Guardian</li>
        <p>Clearly name the guardian in your will to avoid misinterpretation or disputes. Before making the appointment, 
        confirm the guardian is both willing and capable of taking on the responsibility. Consider 
        factors such as their ability to provide stability, emotional support, and financial security for your child.
         Ensuring open communication with the chosen guardian will help prevent future complications and give you peace 
         of mind that your child will be in good hands.</p>
         <li>Consider a Testamentary Trust</li>
         <p>Minors cannot directly inherit assets in South Africa. A <a href="/articles/understanding-testamentary-trusts" class="article-link">testamentary trust</a> allows a trustee to manage the inheritance 
         until the child reaches adulthood.</p>
          <li>Appoint a Backup Guardian</li>
         <p>Having a secondary guardian ensures continuity of care if the primary guardian is unable to fulfil their role.</p>
          <li>Seek Expert Support</li>
         <p><a href="/register" class="article-link">Creating your will</a> with Old Mutual Will ensures that your will is legally valid and compliant with South African law. 
         Our guided process simplifies will creation, helping you avoid common pitfalls ensuring your wishes are clearly documented. With expert support, 
         you can create your will with confidence, securing your child's future with ease.</p>
        </ol>`,
        `<CreateYourWillBanner bannerText="Protect your child's future" />`,
        `<h2 class="mt-0">Factors to Consider When Choosing a Guardian</h2>`,
        `<blockquote>A guardian is more than a caretaker - they shape your child’s future by providing emotional support, 
        stability, and guidance.</blockquote>`,
        `<ol>
        <li>Location and Residency</li>
        <p>Consider the guardian’s location. If they live far away or in another country, moving your child might introduce additional stress. Ensure that your child can legally reside in the guardian’s country if they live abroad.</p>
        <li>Stability and Financial Security</li>
        <p>The guardian’s financial stability and personal circumstances are key. Ensure they can provide a stable and nurturing environment for your child.</p>
        <li>Shared Values and Parenting Philosophy</li>
        <p>The guardian should ideally share similar values, cultural practices, and religious beliefs with you. This ensures continuity in the child’s upbringing and can ease their transition.</p>
        <li>Existing Relationship with Your Child</li>
        <p>The guardian should have a strong, positive relationship with your child. This familiarity can provide much-needed comfort and stability during a challenging time.</p>
        <li>Willingness and Capability</li>
        <p>It’s essential that the person you choose is willing and able to take on the responsibility.
         It’s advisable to discuss your decision with them in advance to ensure they are prepared for this role.</p>
        </ol>`,
        `<h2 class="mt-0">Legal Guardian vs. Godparent</h2>`,
        `<p>Naming someone as a godparent does not automatically grant them legal guardianship. Ensure the guardian is explicitly named in a valid will to secure 
        legal authority.</p>`,
        `<h2 class="mt-0">How Many Guardians Should You Appoint?</h2>`,
        `<p>It is advisable to appoint both a primary and a secondary guardian to ensure your child’s care is never left uncertain.</p>`,
        `<h2 class="mt-0">Managing Your Child’s Inheritance: The Role of a Testamentary Trust</h2>`,
        `<p>When appointing a guardian, it’s also important to consider the financial management of your child’s inheritance.
         In South Africa, minors cannot directly receive an inheritance due to their lack of contractual capacity. 
         Instead, the funds are typically placed in the Guardian’s Fund, a state fund managed by the Master of the High Court. 
         However, this may not always be the ideal solution.</p>`,
        `<p>To better safeguard your child’s inheritance, you can establish a <a href="/articles/understanding-testamentary-trusts" class="article-link">testamentary trust</a> in your will. 
         This trust comes into effect upon your passing and is managed by trustees you appoint. It allows you to 
         dictate how and when the inheritance will be distributed to your child, providing a layer of protection 
         and ensuring that the funds are used in your child’s best interests. It is generally recommended to appoint 
         different people as the legal guardian and trustee to prevent conflicts of interest.</p>`,
        `<p>To learn more about testamentary trust, read our article <a href="/articles/understanding-testamentary-trusts" class="article-link">The Role of Testamentary Trusts in Estate Planning.</a></p>`,
        `<h2 class="mt-0">What Happens if No Guardian is Appointed?</h2>`,
        `<blockquote>Without a named guardian, your child’s future could be left to chance. Ensure their security by appointing someone who aligns with your values.</blockquote>`,
        `<p>If no guardian is named, the High Court will intervene, potentially leading to:</p>`,
        `<ul>
        <li>Family disputes over guardianship.</li>
        <li>A court-appointed guardian who may not align with your wishes.</li>
        <li>The child being placed in state care until a decision is made.</li>
        </ul>`,
        `<h2 class="mt-0">Can You Change the Appointed Guardian?</h2>`,
        `<p>Yes, you can amend your will to change the guardian at any time, provided it follows the 
        legal requirements outlined in the Wills Act 7 of 1953.</p>`,
        `<h2 class="mt-0">Updating Your Will as Circumstances Change</h2>`,
        `<p>Regularly reviewing your will ensures the appointed guardian remains the best choice as circumstances evolve.</p>`,
        `<h2 class="mt-0">Conclusion</h2>`,
        `<blockquote>A well-planned will is a lasting gift to your child, ensuring they are always in safe hands.</blockquote>`,
        `<p>Appointing a guardian is one of the most responsible steps you can take to protect your child’s future. Make this important decision today to safeguard your child’s well-being and provide peace of mind.</p>`,
        `<p class="om-green"><a href="/register">Create your will</a> today and protect what matters most with our trusted, expert-backed process.</p>`,
      ],
    },
    //   title: "Divorce and Wills – What You Need To Know"
    {
      id: 3,
      category: "Wills",
      date: "Apr 23, 2024",
      route: "divorce-and-wills-what-you-need-to-know",
      description: `Divorce is a significant life event that can have lasting financial and legal implications. 
      One of the most important but often overlooked aspects of post-divorce planning is updating your will. 
      Failing to do so may result in unintended beneficiaries inheriting your assets or legal complications for your estate. 
      South African law includes specific provisions to address inheritance rights following a divorce, 
      but it is up to individuals to ensure that their will accurately reflects their new circumstances and wishes.`,
      imageUrl: require("@/assets/shared/redesign/articles/articles3.svg"),
      pathName: "Divorce and Wills",
      heroTitle: "Divorce and Wills – What You Need To Know",
      heroDescription:
        "Protect Your Legacy: Why Updating Your Will After Divorce is Essential for Your Estate and Loved Ones",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Create Your Will Online | Articles",
      metaDescription:
        "Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.",
      content: [
        `<h2 class="mt-0">Understanding Section 2B of the Wills Act</h2>`,
        `<p>South Africa’s Wills Act 7 of 1953 includes an important provision—Section 2B—that directly affects divorced individuals.</p>`,
        `<h2 class="mt-0">How Section 2B Works</h2>`,
        `<p>Section 2B stipulates that if a person passes away within three months of finalizing their divorce, 
        their ex-spouse is treated as if they predeceased them. This means that unless the will explicitly states otherwise, 
        the ex-spouse will not inherit any assets, even if they are named as a beneficiary.</p>`,
        `<h2 class="mt-0">The Three-Month Window</h2>`,
        `<p>The purpose of this provision is to give recently divorced individuals time to amend their wills without their ex-spouse automatically benefiting.
         However, if the will remains unchanged after three months, the law assumes that the testator intended for 
         their ex-spouse to inherit, and they will be entitled to any assets left to them in the will.</p>`,
        `<blockquote>If you do not update your will within three months of the divorce, 
         your ex-spouse may still inherit under your original will.</blockquote>`,
        `<h2 class="mt-0">The Risks of Not Updating Your Will After Divorce</h2>`,
        `<p>Failing to review your will after a divorce can create several legal and financial challenges:</p>`,
        `<ul>
        <li><strong>Unintended Beneficiaries</strong> - If your will remains unchanged after three months, 
        your ex-spouse may still inherit your assets, even if that is not your intention.</li>
        <li><strong>Family Disputes</strong> – Ambiguities in your will could lead to disagreements among family members, 
        creating unnecessary stress and potential legal battles.</li>
        <li><strong>Complex Estate Administration</strong> – Outdated wills can complicate the 
        estate administration process, delaying the distribution of assets to your intended beneficiaries.</li>
        </ul>`,
        `<blockquote>
        Protect your estate and ensure your assets go to the right people by updating your will after a divorce.
        </blockquote>`,
        `<CreateYourWillBanner bannerText="Secure your family's future" />`,
        `<h2 class="mt-0">What You Should Do After a Divorce</h2>`,
        `<ol>
        <li>Review and Update Your Will</li>
        <p>The safest way to ensure that your estate is distributed according to your wishes is to review and update your will 
        immediately after your divorce. Removing an ex-spouse as a beneficiary or appointing new executors and guardians (if necessary) 
        will help align your <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate plan</a> with your new circumstances.</p>
        <li>Consider a Testamentary Trust</li>
        <p>If you have children with your ex-spouse, setting up a <a href="/articles/understanding-testamentary-trusts" class="article-link">testamentary trust</a> can protect their inheritance while 
        ensuring that your ex-spouse does not control the funds on their behalf.</p>
        <li>Appoint a New Executor</li>
        <p>If your ex-spouse is named as your <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a>, consider appointing a new professional 
        or trusted individual to manage your estate after your passing.</p>
        </ol>`,
        `<h2 class="mt-0">How Old Mutual Can Help</h2>`,
        `<p>Old Mutual Will offers a secure and easy-to-use platform that allows you to <a href="/register" class="article-link">create or update</a> a 
        legally valid will online. Our guided process ensures that your will reflects your current wishes 
        and protects your loved ones from potential legal complications.</p>`,
        `<ul>
        <li>Free and simple online will drafting.</li>
        <li>Legally valid wills that comply with South African law.</li>
        <li>Guided process to ensure your will is correctly structured.</li>
        </ul>`,
        `<blockquote>Take control of your estate planning today. 
        Create or update your will with Old Mutual Will to safeguard your legacy.</blockquote>`,
        `<h2 class="mt-0">Conclusion</h2>`,
        `<p>Divorce changes many aspects of life, and your <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate plan</a> should be no exception. 
        Reviewing and updating your will is essential to ensure that your assets are distributed according to your wishes 
        and that your loved ones are protected. Failing to update your will could lead to unintended consequences, 
        including your ex-spouse inheriting assets you no longer wish to leave to them.</p>`,
        `<p class="om-green"><a href="/register">Create or update</a> your will today with Old Mutual Will and secure your legacy with confidence.</p>`,
      ],
    },
    //   title: "Executor of Will - Why Do You Need A Professional Executor"
    {
      id: 4,
      category: "Executor",
      date: "Apr 16, 2024",
      route: "executor-of-will-why-do-you-need-a-professional-executor",
      description: `One of the most crucial decisions when drafting a will is appointing the right executor. 
      This individual or institution is responsible for managing and finalizing your estate after your passing. 
      Many underestimate the complexity of this role, assuming any trusted friend or family member can take it on. 
      However, estate administration involves intricate legal, financial, and tax-related processes that require expertise. 
      A professional executor ensures your wishes are carried out efficiently and that your loved ones are cared for without 
      unnecessary delays or complications.`,
      imageUrl: require("@/assets/shared/redesign/articles/articles4.jpg"),
      pathName: "Executor of Will",
      heroTitle: "Executor of Will – Why You Need a Professional Executor ",
      heroDescription:
        "Choosing the Right Executor: Professional expertise for efficient estate management, legal compliance, and fair distribution.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Create Your Will Online | Articles",
      metaDescription:
        "Choosing the Right Executor: Professional expertise for efficient estate management, legal compliance, and fair distribution.",
      content: [
        `<h2 class="mt-0">What Does an Executor Do?</h2>`,
        `<blockquote>An executor is responsible for handling all legal, financial, and administrative duties to ensure a deceased person's 
        estate is properly managed and distributed.</blockquote>`,
        `<p>The executor is responsible for settling your estate, ensuring that assets are distributed according to your will, 
        and handling legal obligations. The key duties of an executor include:</p>`,
        `<ol>
        <li>Gathering Information</li>
        <p>The executor must collect and verify all information regarding your assets and liabilities. This includes bank accounts, 
        property deeds, investments, debts, and any outstanding financial commitments.</p>
        <li>Managing Assets</li>
              <p>If your estate includes income-generating assets, the executor oversees them until the estate is fully settled. 
              They may need to manage rental properties, investments, or businesses to maintain financial stability.</p>
        <li>Paying Debts and Taxes</li>
              <p>Before distributing assets to beneficiaries, the executor must settle all outstanding debts, estate taxes, and other financial obligations. 
              This process often requires financial acumen and negotiation skills, particularly when dealing with creditors.</p>
        <li>Distributing Assets to Beneficiaries</li>
              <p>Once debts are cleared, the executor ensures that assets are distributed as specified in your will. 
              This involves legal documentation and financial transactions to transfer ownership efficiently.</p>
        <li>Resolving Disputes</li>
              <p>In some cases, disputes may arise among beneficiaries or between creditors and debtors. 
              A professional executor has the experience to mediate conflicts and ensure a smooth estate administration process.</p>
        </ol>`,
        `<h2 class="mt-0">Why Choose a Professional Executor?</h2>`,
        `<p>While appointing a close friend or family member may seem logical, this choice can lead to unintended consequences. 
        Estate administration is complex, and an inexperienced executor may struggle with legal procedures, financial obligations, 
        and family disputes. Here’s why choosing a professional executor is beneficial:</p>`,
        `<ol>
        <li>Expertise in Legal and Financial Matters</li>
        <p>A professional executor, such as Old Mutual, has extensive experience in estate law, financial planning, and tax regulations. 
        They ensure compliance with legal requirements, reducing the risk of costly mistakes or delays.</p>
        <li>Impartiality and Conflict Resolution</li>
        <p>Family members may have personal interests or emotional biases that can lead to conflicts when managing an estate. A professional executor remains neutral, ensuring that decisions are made fairly and in accordance with the will.</p>
        <li>Efficient Estate Administration</li>
        <p>An experienced executor streamlines the probate process, which is the legal procedure through which a deceased person's estate is validated, debts are settled, and assets are distributed to beneficiaries. Handling administrative tasks efficiently ensures beneficiaries receive their inheritance without unnecessary delays.</p>
        <li>Protection Against Financial Risks</li>
        <p>If an executor mismanages an estate, they can be held legally responsible for financial losses. A professional executor mitigates this risk by adhering to best practices and legal protocols.</p>
        <blockquote>Choosing a professional executor ensures that your estate is managed with professionalism, efficiency, and fairness, minimizing stress for your loved ones.</blockquote>
        </ol>`,
        `<CreateYourWillBanner />`,
        `<h2 class="mt-0">Understanding Executor Fees</h2>`,
        `<p>Executor fees are regulated and typically calculated as a percentage of the estate’s total value.</p>`,
        `<p>In South Africa these fees are:</p>`,
        `<ul>
        <li><strong>3.5%</strong> of the gross value of the estate, plus VAT.</li>
        <li><strong>6%</strong> of all income generated by the estate during administration, plus VAT.</li>
        <ul>`,
        `<p>Ensuring that your estate has sufficient liquidity to cover these costs is essential. 
        Without proper planning, the executor may need to sell assets intended for beneficiaries to settle expenses. 
        Old Mutual provides an <a href="/estate-administration-cost-calculator" class="article-link">estate administration cost calculator</a> to help estimate these fees and plan accordingly.</p>`,
        `<h2 class="mt-0">Appointing Old Mutual as Your Executor</h2>`,
        `<p>Appointing a professional executor like Old Mutual ensures that your estate is managed with care and expertise. 
        With extensive knowledge of estate law and administration, Old Mutual can:</p>`,
        `<ul>
        <li>Handle complex financial and legal matters.</li>
        <li>Mediate disputes impartially.</li>
        <li>Ensure timely and efficient estate settlement.</li>
        <li>Protect beneficiaries’ interests while minimizing risks.</li>
        </ul>`,
        `<blockquote>Secure your legacy and protect your loved ones with Old Mutual’s professional executor services.</blockquote>`,
        `<h2 class="mt-0">Conclusion</h2>`,
        `<p>Appointing the right executor is a critical step in ensuring your final wishes are fulfilled smoothly. 
        While a trusted friend or family member may seem like the best choice, estate administration requires legal knowledge, 
        financial expertise, and impartiality. A professional executor guarantees that your estate is managed efficiently, 
        your debts are settled correctly, and your beneficiaries receive their inheritance without unnecessary stress.</p>`,
        `<p class="om-green">Make the right choice today. <a href="/register">Create your legal will</a> with Old Mutual Will 
        and appoint a trusted professional executor to safeguard your estate.</p>`,
      ],
    },
    // title: "Wills in South Africa - 70% of South Africans Die Without a Will"
    {
      id: 5,
      category: "Wills",
      date: "Apr 16, 2024",
      route: "wills-in-south-africa",
      // title: "Wills in South Africa - 70% of South Africans Die Without a Will",
      // description: `70% of South Africans die without a will, leaving their families to deal with a significant amount of administration while grieving.`,
      imageUrl: require("@/assets/shared/redesign/articles/articles5.jpg"),
      pathName: "Wills in South Africa",
      heroTitle:
        "Wills in South Africa - 70% of South Africans Die Without a Will",
      heroDescription:
        "70% of South Africans die without a will, leaving their families to deal with a significant amount of administration while grieving.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Create Your Will Online | Articles",
      metaDescription:
        "Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.",
      content: [
        `<p class="mt-0">If you’re wondering whether you need a will, you probably do. 
        70% of South Africans die without a valid will, leaving their families to deal with a significant amount 
        of administration while grieving.</p>`,
        `<p>By creating a will, you protect your family by lessening the administrative burden while they grieve your 
        death and allowing them to access funds or assets that could be essential for their ongoing maintenance and support.</p>`,
        `<p>If you die without a will, your estate is administered according to the laws in the 
        Intestate Succession Act, which prescribes a structure for dividing your assets between family.</p>`,
        `<blockquote>70% of South Africans die without a will, burdening their families with administration. Creating a will eases this by ensuring your assets are distributed as 
        you wish, not by the Intestate Succession Act.</blockquote>`,
        `<h2>Appointing an Executor</h2>`,
        `<p>Writing a will allows you to appoint an <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> 
        who will take care of the administration of your estate upon your passing. Old Mutual Will’s Estate Administrator is a
         panel of qualified executors in Cape Town and Johannesburg.</p>`,
        `<p>We recommend you choose an <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a>, 
        who can then negotiate the legally prescribed maximum fee of 3.5% (plus VAT) on the gross value of your estate when the time comes. 
        By appointing the <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a>, 
        you are eliminating the process where your family needs to nominate executors (with motivation), which then needs to be approved by the 
        Master of the High Court before they can proceed with the administration of your estate.</p>`,
        `<blockquote>Appointing an executor ensures efficient estate administration, avoiding delays and legal formalities. 
        Old Mutual Will's qualified <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executors</a> manage the process, 
        protecting your family from additional burdens during a difficult time.</blockquote>`,
        `<h2>Appoint a guardian for your minor children</h2>`,
        `<p>If you have minor children, you must make provision for their legal <a href="/articles/appointing-a-guardian-in-your-will-a-comprehensive-guide" class="article-link"> guardians.</a>
         You appoint legal <a href="/articles/appointing-a-guardian-in-your-will-a-comprehensive-guide" class="article-link"> guardians</a> for your children in a will. 
        This means that upon your passing, these guardians will legally be considered to be the caretakers of your children.</p>`,
        `<p>Should you fail to appoint a <a href="/articles/appointing-a-guardian-in-your-will-a-comprehensive-guide" class="article-link"> guardian</a> for your children, 
        an application will have to be made to the High Court to appoint someone as the guardian for your children. 
        People close to you must step forward to implement this process and ensure your children have a legal guardian.</p>`,
        `<blockquote>Appointing legal <a href="articles/appointing-a-guardian-in-your-will-a-comprehensive-guide" class="article-link">guardians</a> in a 
        will ensures your minor children are cared for, avoiding lengthy court 
        processes and providing them with stability during a challenging time.</blockquote>`,
        `<CreateYourWillBanner bannerText="Protect your family's future" />`,
        `<h2>Set up Testamentary Trusts for minor children</h2>`,
        `<p>Another consideration with minor children is ensuring they can readily access their inheritance. 
        This can be achieved by leaving their portion of the inheritance to your spouse and their parent with the understanding that they
         will apply it towards the care of the family.</p>`,
        `<p>Alternatively, you can create a <a href="/articles/understanding-testamentary-trusts" class="article-link">Testamentary Trust</a>, in which the children’s inheritance is kept and managed
         until the trust terminates. You can choose when the trust terminates. In the absence of an arrangement like this, 
         the children’s inheritance will be held by the Guardian’s Fund (a government association), and their guardians will have 
         to apply for funds to be released as and when the children need it, making it a slow and administratively intensive process.</p>`,
        `<blockquote>Ensure your minor children's inheritance is managed efficiently by creating a 
         <a href="/articles/understanding-testamentary-trusts" class="article-link">Testamentary Trust</a>. This ensures that their inheritance is managed on their behalf until they 
         are ready to take on this responsibility themselves.</blockquote>`,
        `<h2>For swift administration of your estate and peace of mind</h2>`,
        `<p>You may find yourself in a situation where you do not have a lot of assets or money and think that it’s not 
        necessary for you to have a will because your estate is too small. If you have people who are dependent on you for 
        financial help for schooling or medication, for instance, having a will ensures that the monies that can help them are 
        released much sooner than if you were to die without a will.</p>`,
        `<h2>Leave gifts or assets to specific people/charities</h2>`,
        `<p>It is essential to put those in your will if you have assets or money that you want to leave to particular people or charities. 
        Otherwise, your wishes cannot be legally adhered to.</p>`,
        `<p>It’s clear that having a will safeguards and protects your family while ensuring your wishes are adhered to and 
        your estate is administered in an organized and swift manner.</p>`,
        `<p class="om-green"><a href="/register">Create your will</a> today and protect what matters most with our trusted, expert-backed process.</p>`,
        `<p>
        <strong>Sources:</strong></br/></br/>
        <a href="https://www.justice.gov.za/master/wills-is.html" class="article-link" target="_blank">https://www.justice.gov.za</a></p>`,
      ],
    },
    //title "default title"
    {
      id: 6,
      category: "Estate Planning",
      date: "Oct 29, 2024",
      route: "understanding-testamentary-trusts",
      description: `A testamentary trust is a crucial element in estate planning, especially for those looking to protect and manage their assets for the benefit of their loved ones after their passing.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image5.jpg"),
      pathName: "Understanding Testamentary Trusts",
      heroTitle: "The Role of Testamentary Trusts in Estate Planning",
      heroDescription:
        "A testamentary trust is vital in estate planning to protect and manage assets for your loved ones' future.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle:
        "Understanding Testamentary Trusts and Their Role in Estate Planning",
      metaDescription:
        "A testamentary trust is vital in estate planning to protect and manage assets for your loved ones' future. Create your will online today with Old Mutual.",
      content: [
        `<h2 class="mt-0">Why Testamentary Trusts Are Essential for Estate Planning</h2>`,
        `<p>This type of trust is established through your will and only comes into effect upon your death.
         It serves as a protective mechanism, ensuring that your assets are managed according to your wishes and that vulnerable beneficiaries, such as minor children or dependent family members,
          are well taken care of.</p>`,
        `<blockquote>A testamentary trust, established through your will, provides a way to protect and manage 
          assets for vulnerable beneficiaries, such as minor children, ensuring they’re cared for according to your wishes.</blockquote>`,
        `<h2>Who Should Consider a Testamentary Trust?</h2>`,
        `<p>A testamentary trust may be particularly beneficial if:</p>`,
        `<ul>
        <li>You have children under 18 who are financially dependent on you.</li>
        <li>You have vulnerable family members, such as elderly parents or adult children who may not manage their inheritance responsibly.</li>
        <li>You want to ensure your loved ones are financially secure and their inheritance is managed wisely after your death.</li>
        </ul>`,
        `<blockquote>A testamentary trust is ideal if you have minor children, vulnerable family members, or want to ensure your loved ones’ inheritance is managed responsibly.</blockquote>`,
        `<h2>Purpose of a Testamentary Trust</h2>`,
        `<p>In South Africa, minor children cannot directly receive an inheritance. Without a testamentary trust, any assets left to them may be sold and placed 
      in the Guardian’s Fund or held by their legal guardian. A testamentary trust ensures that these assets are managed and utilised 
      in the best interests of the beneficiaries, offering peace of mind that your children or other vulnerable family members will 
      be cared for when you are no longer able to do so. This trust also allows you to specify how and when funds should be distributed, 
      giving you control over the financial future of your loved ones even after your passing.</p>`,
        `<blockquote>In South Africa, minors cannot directly receive an inheritance. A testamentary trust ensures that these assets are responsibly managed until beneficiaries reach an appropriate age or maturity level.</blockquote>`,
        `<h2>How Testamentary Trusts Work</h2>`,
        `<ul>
          <li>Testamentary trusts are created based on instructions in your will, detailing the creation of the trust, who the trustees will be, and what powers they will have.</li>
          <li>The trust only comes into existence after your death, meaning your assets are still subject to estate duty before being transferred into the trust.</li>
          <li>It’s crucial to ensure that your will is legally valid, as an invalid will would nullify the trust.</li>      
        </ul>`,
        `<blockquote>Created through your will, testamentary trusts only come into effect after death, providing control over when and how assets are distributed to beneficiaries.</blockquote>`,
        `<h2>Appointing a Trustee</h2>`,
        `<p>The trustee plays a vital role in managing the inheritance within the trust. It’s important to appoint someone with the necessary 
      skills and experience to make decisions in the best interest of your beneficiaries. While you may choose the same person to be 
      both the trustee and guardian, it is often advisable to select an independent trustee to avoid potential conflicts of interest.</p>`,
        `<blockquote>Choosing a trustee with the skills and experience to manage the trust responsibly is essential. It’s often advisable to appoint an independent trustee to avoid conflicts of interest.</blockquote>`,
        `<h2>Old Mutual Will Offers Testamentary Trusts as Part of Our Online Will Creation Process</h2>`,
        `<p>When you create your will with Old Mutual Will, we offer you the opportunity to establish a testamentary trust as part of our comprehensive and guided process. This ensures that your estate plan is tailored to protect the interests of your loved ones, 
      providing you with peace of mind that your wishes will be honoured.</p>`,
        `<blockquote>Old Mutual Will offers the option to establish a testamentary trust within its online will creation process, making it easy to protect the interests of your loved ones.</blockquote>`,
        `<h2>Exploring Inter Vivos Trusts for More Complex Estate Planning Needs</h2>`,
        `<h2 class="sub-heading-one">What Is an Inter Vivos Trust?</h2>`,
        `<p>An inter vivos trust, also known as a living or family trust, is another important estate planning tool, but unlike a 
      testamentary trust, it is established during your lifetime. This trust can be used to manage and protect assets both 
      while you are alive and after your death, making it a versatile option for those with more complex estate planning needs.</p>`,
        `<blockquote>Unlike a testamentary trust, an inter vivos trust is set up during your lifetime and allows you to manage and protect assets both now and after your death.</blockquote>`,
        `<h2 class="sub-heading-one">Who Should Consider an Inter Vivos Trust?</h2>`,
        `<p>This type of trust may be suitable if you:</p>`,
        `<ul>
           <li>Have significant assets that you wish to preserve and pass down through generations.</li>
          <li>Want to support your beneficiaries financially during your lifetime and ensure seamless management of these assets after your death.</li>
          <li>Seek to protect your assets from potential risks, such as business failure or personal financial challenges.</li>
          <li>Want to minimize the impact of estate duties and other costs upon your death.</li>
        </ul>`,
        `<h2 class="sub-heading-one">How an Inter Vivos Trust Works</h2>`,
        `<ul>
          <li>The trust is established while you are alive, with the terms set out in a trust deed that reflects your wishes.</li>
          <li>You can transfer assets into the trust during your lifetime, either through a loan or donation, but it’s important to be aware of the tax implications of these transactions.</li>
          <li>The trustees, who are bound by the trust deed and trust legislation, manage the assets according to your specified terms.</li>
        </ul>`,
        `<h2 class="sub-heading-one">Key Benefits of an Inter Vivos Trust</h2>`,
        `<p class="mb-6 mt-6 semi-bold">Asset Protection Across Generations</p>`,
        `<p>By placing assets in a trust, you can protect them from poor decision-making by beneficiaries and ensure they remain within your family for future generations.</p>`,
        `<p class="mb-6 mt-6 semi-bold">Tax Efficiency</p>`,
        `<p>Transferring growth assets to a trust can help reduce estate duty, as the assets’ value increases within the trust, not in your personal estate.  
        It should be noted that you should consider a comprehensive view on the tax implications of an inter vivos trust as part of your broader estate plan.</p>`,
        `<p class="mb-6 mt-6 semi-bold">Continuity of Asset Management</p>`,
        `<p>An inter vivos trust allows for seamless management of your assets, reducing the disruption that may occur upon your death.</p>`,
        `<blockquote>An inter vivos trust provides asset protection across generations, tax efficiency, and seamless asset management, making it an essential tool for those with complex estate planning needs.</blockquote>`,
        `<h2>More Complex Estate Planning </h2>`,
        `<p>For those with more intricate estate planning needs, an inter vivos trust can be an essential component of a comprehensive strategy. 
        It allows you to structure your estate in a way that protects your assets from various risks, provides for your beneficiaries,
         and minimizes taxes and costs. This trust can also be used in conjunction with a testamentary trust to ensure that both immediate and 
         long-term estate planning goals are met.</p>`,
        `<h2>Conclusion</h2>`,
        `<blockquote>Incorporating a testamentary trust into your estate plan is a powerful way to ensure your assets are protected and managed 
         according to your wishes, especially for the benefit of vulnerable loved ones.</blockquote>
        <p>Whether you are planning for minor children, 
         dependents with unique needs, or simply wish to safeguard your legacy, a testamentary trust offers peace of mind and financial 
         security for your beneficiaries.</p>
         <p>Ready to take control of your legacy and secure your loved ones' future? With Old Mutual Will, you can easily establish a testamentary trust when you create your will online.`,
        `<p class="article-cta">
         <a href="https://${environmentUrl}/register">
         Create your will</a> today and protect what matters most with a trusted, expert-backed process.
         </p>`,
      ],
    },
    //title "default title"
    {
      id: 7,
      category: "Wills",
      date: "Oct 29, 2024",
      route: "why-you-need-a-last-will-and-testament",
      description: `Creating a <strong>Last Will and Testament</strong> is one of the most crucial steps you can take to secure your family’s 
      future and protect your assets after you're gone. Without a will, your estate could be divided according to <strong>South Africa’s 
      Intestate Succession Act</strong>, which may not align with your wishes. In this guide, we’ll explore why having a will is important for everyone, 
      regardless of age or wealth, and how it offers peace of mind by ensuring that your legacy is handled according to your preferences.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image17.jpg"),
      pathName: "Last Will and Testament: A Comprehensive Guide",
      heroTitle: "Why You Need a Last Will and Testament",
      heroDescription:
        "Ensure your family’s future with a last will and testament that reflects your wishes.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Why You Need a Last Will and Testament",
      metaDescription:
        "Ensure your family’s future with a last will and testament that reflects your wishes. Create your will online today with Old Mutual.",
      content: [
        `<blockquote class="mt-0">Creating a Last Will and Testament is essential for securing your family’s future and protecting your assets. Without a will, 
        your estate could be divided according to South Africa’s Intestate Succession Act, which may not align with your wishes.</blockquote>`,
        `<h2>Why is a Will Important?</h2>`,
        `<p>A <strong>Last Will and Testament</strong> allows you to decide how your assets—such as property, investments, and personal belongings—will be distributed after your death. Here’s why having a will is essential:</p>`,
        `<ol>
          <li>Control Over Asset Distribution</li>
          <p>A will gives you control over who inherits your property. Without one, South African law distributes your assets to your closest relatives under the Intestate Succession Act, which might not reflect your personal wishes. For example, 
          unmarried partners may not automatically inherit under intestate rules.</p>
          <li>Preventing Family Disputes</li>
          <p>A clear and valid will reduces the likelihood of disputes among family members after your passing. Without a will, family disagreements over assets can lead to lengthy legal battles, causing emotional and financial strain.</p>
          <li>Appointing Guardians for Minor Children</li>
          <p>For parents, appointing a legal guardian for minor children is one of the most important reasons to have a will. If both parents pass away, a will ensures your children are cared for by someone you trust, rather than leaving the decision to the courts.</p>
          <li>Minimizing Taxes and Expenses</li>
          <p>A well-structured will can help minimize estate duty and other taxes on your estate. Estate planning tools, such as testamentary trusts, can help you protect assets and ensure they are used wisely by your heirs.</p>
          <li>Simplifying the Estate Administration Process</li>
          <p>By appointing an executor in your will, you make the estate administration process smoother. The executor will ensure that your assets are distributed according to your wishes, debts are paid, and any legal requirements are fulfilled.</p>
          </ol>`,
        `<blockquote>A Last Will and Testament is essential for controlling who inherits your assets, preventing family disputes, and appointing guardians for minor children. It helps minimize taxes, simplifies estate administration, and ensures your wishes are respected,
           providing peace of mind for you and security for your loved ones.</blockquote>`,
        `<h2>Who Needs a Will?</h2>`,
        `<p>Contrary to popular belief, wills aren’t just for the wealthy. In fact, anyone with assets, children, or specific wishes for their estate should create a will. Here’s why it’s essential for different people:</p>`,
        `<ul>
          <li><strong>Parents</strong></li>
          <p>Ensuring guardianship of your children and the management of their inheritance through a testamentary trust.</p>
          <li><strong>Unmarried Partners</strong></li>
          <p>Without a will, your partner may not have a legal right to your assets.</p>
          <li><strong>Homeowners</strong></li>
          <p>Decide who inherits your property and ensure it doesn’t need to be sold to cover estate expenses.</p>
          <li><strong>Business Owners</strong></li>
          <p>Ensure your business continues smoothly by appointing a successor or outlining its future.</p>
        </ul>`,
        `<blockquote>Wills aren’t just for the wealthy—anyone with assets, children, or specific wishes for their estate should create one. It’s essential for parents, 
        unmarried partners, homeowners, and business owners.</blockquote>`,
        `<h2>Common Misconceptions About Wills</h2>`,
        `<p>Many people believe they don’t need a will for various reasons. Let’s dispel some common myths:</p>`,
        `<ul>
          <li><strong>"I’m too young to need a will."</strong></li>
          <p>Even if you are young, having a will ensures that your assets and wishes are respected in the event of an unexpected death.
          A will is a vital tool for those who want to ensure their loved ones are cared for.</p>
          <li><strong>"I don’t own much, so I don’t need a will."</strong></li>
          <p>You don’t need to have a massive estate to benefit from a will. Whether it’s your home, car, or sentimental belongings, 
          a will allows you to decide who gets what. It’s also essential for ensuring that personal items with sentimental value are passed to the right people.</p>
        </ul>`,
        `<h2>Key Elements of a Last Will and Testament</h2>`,
        `<ol>
          <li>Appointing an Executor</li>
            <p>The executor manages your estate, ensuring your assets are distributed according to your will. 
            It’s essential to choose someone who is trustworthy and capable of handling this responsibility. 
            Many people choose professional executors, like Old Mutual, to ensure the estate is properly managed.</p>
          <li>Specific Bequests</li>
            <p>You can decide who inherits specific items such as your home, car, jewellery, or even family heirlooms. 
            This prevents confusion and ensures your assets go to the people you want them to.</p>
          <li>Residual Estate Distribution</li>
            <p>After debts and specific bequests are handled, your residual estate—the remainder of your assets—can be distributed 
            according to your wishes. You can divide this among family, friends, or charitable organizations.</p>
          <li>Appointing a Guardian</li>
            <p>For parents, appointing a legal guardian for your minor children is vital. Without this, the courts 
            may decide who raises your children.</p>     
          <li>Testamentary Trust</li>
            <p>If you have minor children, consider setting up a testamentary trust to manage their inheritance. 
            This ensures that their inheritance is managed responsibly until they reach adulthood.</p>
            </ol>`,
        `<blockquote>A will includes appointing an executor, specific bequests, residual estate distribution, appointing guardians, 
            and setting up testamentary trusts for minors.</blockquote>`,
        `<h2>How to Create Your Will</h2>`,
        `<ol>
        <li>Find Trusted Expertise</li>
          <p>Although you can write your own will, it's best to use a professional service like <strong>Old Mutual’s online will service</strong> 
          to ensure your will is legally sound and reflects your true wishes. In the case of highly complex estates, 
          it may be advisable to speak to a legal or financial adviser.</p>
         <li>List Your Assets</li>
          <p>Before creating your will, take an inventory of your assets, including property, savings, and personal belongings.</p> 
          <li>Appoint Key Roles</li>
            <p>Decide who will serve as your executor, guardians for your children, and trustees for any testamentary trusts.</p>
           <li>Sign and Witness</li>
          <p>For a will to be legally binding, it must be signed in the presence of two witnesses who are not beneficiaries.</p>
            <li>Store Your Will Safely</li>
          <p>Once your will is signed, store it in a safe place and ensure that your executor and close family members know where to find it.</p>   
        </ol>`,
        `<blockquote>Old Mutual’s online service provides a secure, professional way to create a will that’s legally sound and reflects your wishes. 
        For complex estates, consult a legal adviser.</blockquote>`,
        `<h2>Conclusion: Secure Your Legacy Today</h2>`,
        `<p>Creating a <strong>Last Will and Testament</strong> is an essential step to protect your loved ones and ensure that 
        your assets are distributed according to your wishes. Whether you’re a parent, homeowner, or simply want peace 
        of mind, a will allows you to take control of your legacy.</p>`,
        `<p class="article-cta">
         Take the first step today. <a href="https://${environmentUrl}/register">Create your will</a> online with a trusted, expert-backed process.
         </p>`,
      ],
    },
    //title "default title"
    {
      id: 8,
      category: "Wills",
      date: "Oct 29, 2024",
      route: "step-by-step-guide-to-writing-a-last-will-and-testament",
      description: `Creating a Last Will and Testament is an important step in securing the future of your loved ones and ensuring that your wishes 
      are respected after you pass away. Using Old Mutual's online will service makes this process easier, quicker, and more convenient. 
      This service provides a 7-step guided process that takes you through every aspect of drafting a comprehensive will, from your personal 
      details to protecting your estate.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image18.jpg"),
      pathName: "Step by Step Guide To Writing a Last Will and Testament",
      heroTitle: "Your Guide to Writing Your Last Will and Testament",
      heroDescription:
        "Secure your loved ones' future with Old Mutual's easy 7-step online will creation process.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle:
        "Step-by-Step Guide to Writing Your Last Will and Testament Online",
      metaDescription:
        "Secure your loved ones' future with Old Mutual's straightforward 7-step online will creation process. Create your will online today.",
      content: [
        `<blockquote class="mt-0">Creating a Last Will and Testament is an important step in securing your loved ones' future and ensuring that your wishes are respected. 
        Old Mutual's online will service provides a 7-step guided process to make this easier, quicker, and legally sound.</blockquote>`,
        `<p>In this guide, we’ll explain how each step in the Old Mutual Will process works and highlight the benefits of using their online platform, 
        which ensures your will is legally valid and expertly reviewed.</p>`,
        `<h2>Step 1: About Yourself</h2>`,
        `<p>The first step in drafting your will with Old Mutual Will is to provide essential personal information. This includes:</p>`,
        `<ul>
        <li>Full name and ID number</li>
        <li>Date of birth</li>
        <li>Contact details</li>
        <li>Marital status</li>
        </ul>`,
        `<p>Providing these details is critical because they help to formally identify you in the will and ensure it is legally binding. 
        The Old Mutual Will platform makes this step easy by guiding you through a secure, user-friendly process to input your personal data.</p>`,
        `<blockquote>Provide personal information, like your name and marital status, to make your will legally binding.</blockquote>`,
        `<h2>Step 2: About Your People</h2>`,
        `<p>In this step, you’ll identify the important people in your life who will play key roles in your will, including:</p>`,
        `<ul>
          <li><strong>Beneficiaries</strong></li>
          <p>The individuals or organizations who will inherit your assets. This could include family members, friends, or charitable organizations.</p>
          <li><strong>Guardians</strong></li>
          <p>If you have minor children, appointing a legal guardian is essential to ensure they are cared for by someone you trust if both parents pass away.</p>
          <li><strong>Executor</strong></li>
          <p>The person responsible for managing your estate and carrying out the instructions in your will. Typically you can choose a trusted family member, 
          a friend, but by using the Old Mutuals online will creation service you will have the benefit of appointing Old Mutual as professional executor to 
          ensure your estate is handled smoothly.</p>
        </ul>`,
        `<blockquote>Identify key individuals, such as beneficiaries, guardians for minors, and an executor.</blockquote>`,
        `<h2>Optional Step: Testamentary Trust</h2>`,
        `<p>If you have minor children or vulnerable dependents, Old Mutual’s online will service allows you to easily set up a testamentary trust. 
        This trust is created in your will and ensures that your children’s inheritance is managed responsibly until they are of age or capable of handling
         the assets themselves. The trust can help protect the assets from being misused and ensures that they are distributed according to your wishes.</p>`,
        `<p>The Old Mutual platform makes it easy to include this option by guiding you through the process of establishing the trust, selecting trustees, 
         and specifying how and when assets should be distributed.</p>`,
        `<blockquote>Set up a testamentary trust for minors, ensuring responsible management of their inheritance until they come of age.</blockquote>`,
        `<h2>Step 3: Your Assets</h2>`,
        `<p>This step is all about detailing your assets, including:</p>`,
        `<ul>
         <li>Real estate (such as homes and land)</li>
         <li>Financial accounts (such as savings, investments and retirement accounts)</li>
         <li>Personal belongings (such as vehicles, jewellery and heirlooms)</li>
         </ul>
         <p>Listing your assets ensures that nothing is overlooked when it comes to distributing your estate. 
         Old Mutual’s online will service provides a structured format for inputting these assets, giving you the opportunity to 
         capture everything from valuable possessions to smaller sentimental items.</p>`,
        `<blockquote>List your assets, including real estate, financial accounts, and personal belongings.</blockquote>`,
        `<h2>Step 4: Specific Bequests</h2>`,
        `<p>In this step, you decide who will receive specific items from your estate, such as:</p>`,
        `<ul>
         <li>Property (e.g., a house to a child)</li>
         <li>Valuables (e.g., jewellery or family heirlooms)</li>
         <li>Monetary gifts (e.g., a set amount to a friend or charity)</li>
         </ul>
         <p>The Old Mutual platform makes it easy to allocate specific bequests to beneficiaries, ensuring that your instructions are clear and legally enforceable.</p>`,
        `<blockquote>Assign specific items, like property or jewellery, to specific beneficiaries in accordance with your wishes.</blockquote>`,
        `<h2>Step 5: Distribution of the Remainder of the Estate</h2>`,
        `<p>Once your specific bequests have been handled, the rest of your estate needs to be distributed. This step allows you to decide how the 
         remainder of your estate will be allocated among your beneficiaries. You can:</p>`,
        `<ul>
         <li>Divide the remaining assets equally.</li>
         <li>Allocate different percentages or amounts to each beneficiary.</li>
         </ul>
         <p>This ensures that your estate is fully accounted for and distributed according to your wishes. Old Mutual’s 
         guided process walks you through this step with easy-to-understand options.</p>`,
        `<blockquote>Decide how to divide the remainder of your estate among beneficiaries. The Old Mutual platform offers 
         relevant information that helps you make the best decisions for your scenario.</blockquote>`,
        `<h2>Step 6: Living Will and Letter of Wishes (Optional)</h2>`,
        `<p>A Living Will outlines your preferences for medical care and treatment if you become incapacitated and 
         unable to communicate your wishes. This could include instructions about:</p>`,
        `<ul>
         <li>Receiving or refusing life-sustaining treatments.</li>
         <li>Preferences for palliative care.</li>
         </ul>
         <p>In addition to the Living Will, you can also include a Letter of Wishes. While not legally binding, this 
         document provides guidance to your executor or loved ones about your personal desires, such as funeral arrangements or other personal messages to your family.</p>`,
        `<p>Old Mutual’s platform allows you to easily create both a Living Will and a Letter of Wishes to ensure your healthcare preferences and personal requests are respected.</p>`,
        `<blockquote>A Living Will outlines your medical wishes if you can’t communicate, and a Letter of Wishes includes personal requests, like funeral plans.</blockquote>`,
        `<h2>Step 7: Protect Your Estate</h2>`,
        `<p>The final step is about protecting your estate to ensure that your loved ones are not burdened with financial strain during the estate administration process.</p>`,
        `<p>This includes ensuring estate liquidity. It’s important to ensure your estate has enough liquidity to cover expenses like executor fees, taxes, and debts.</p>`,
        `<p>Old Mutual also provides additional optional services to help you plan for these costs, as well as education, 
         debt and cash flow assistance, ensuring your loved ones are taken care of.</p>`,
        `<blockquote>Ensure liquidity to cover executor fees, taxes, and debts. Old Mutual offers services for education, debt, and cash flow assistance to support loved ones.</blockquote>`,
        `<h2>Why Choose Old Mutual Will?</h2>`,
        `<p>Throughout each step of the process, Old Mutual Will provides several advantages:</p>`,
        `<ul>
        <li><strong>Convenience</strong></li>
        <p>You can complete your will online from anywhere, without the need for multiple appointments or legal consultations.<p>
        <li><strong>Expert guidance</strong></li>
        <p>The platform provides clear prompts and guidance at every step to ensure you don’t miss any important details.<p>
        <li><strong>Free verification, collection and storage</strong></li>
        <p>After completing your will, Old Mutual’s legal team will verify that it is legally sound, and then it will be
         collected at a location of your choice and taken into safe storage at no cost to you.<p>
        <li><strong>Easy updates</strong></li>
        <p>Life changes such as marriage, the birth of children, or acquiring new assets can require will updates. 
        Old Mutual Will makes it easy to update your will as needed.<p>
        </ul>`,
        `<h2>Conclusion: Start Creating Your Will Today with Old Mutual’s online will service</h2>`,
        `<blockquote>Creating your Last Will and Testament is one of the most important things you can do to protect your loved ones and ensure your wishes are respected.</blockquote>
        <p>With Old Mutual, the process is simple, secure, and guided every step of the way. From personal information to protecting your estate, 
        the online platform ensures you cover everything with ease.</p>`,
        `<p class="article-cta"><a href="https://${environmentUrl}/register">Create your will</a> today and take control of your legacy.</p>`,
      ],
    },
    //title "default title"
    {
      id: 9,
      category: "Wills",
      date: "Oct 29, 2024",
      route: "free-will-templates-what-you-need-to-know",
      description: `Creating a will is one of the most important steps in planning your estate and ensuring that your wishes are respected after you pass away.
       Many people seek out free will templates as a simple solution, but is it really the best option for everyone? In this article, we will explore what a 
       free will template is, the pros and cons of using one, and what you should keep in mind when considering this option.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image8.jpg"),
      pathName: "Free Will Templates: What You Need to Know Before You Use One",
      heroTitle: "Free Will Templates: What You Need to Know",
      heroDescription:
        "Explore if a free will template suits your needs, its pros and cons, and key considerations.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle:
        "Free Will Templates: What You Need to Know Before You Use One",
      metaDescription:
        "Explore if a free will template suits your needs, its pros and cons, and key considerations. Create your free will online today with Old Mutual.",
      content: [
        `<h2 class="mt-0">What is a Free Will Template?</h2>`,
        `<p>A free will template is a pre-formatted document that allows individuals to create a basic legal will on their own. These templates are readily available online and are designed to help you outline who should inherit your assets, appoint guardians for your children, and choose an executor for your estate. While this may seem like a 
        convenient and cost-effective option, it’s essential to understand the limitations and risks involved.</p>`,
        `<blockquote>A free will template is a pre-formatted document that allows individuals to create a basic legal will on their own. While this may seem like a convenient and cost-effective option, 
        it’s essential to understand the limitations and risks involved.</blockquote>`,
        `<h2>Pros of Using a Free Will Template</h2>`,
        `<ol>
        <li>Cost-Effective</li>
        <p>As the name suggests, the main advantage of a free will template is that it costs nothing to use. For individuals on a budget, 
        it can be an appealing option, especially when compared to the fees of a lawyer or estate planner.</p>
        <li>Convenience</li>
        <p>Free templates are easily accessible online and can be filled out in your own time. This makes it a convenient solution 
        for those who want to get their affairs in order quickly.</p>
        <li>Basic Estate Planning</li>
        <p>If you have a simple estate with minimal assets and straightforward instructions, a free will template can suffice. 
        It's a good starting point for people with small estates who do not anticipate complicated legal matters.</p>
        </ol>`,
        `<blockquote>Free will templates are cost-effective, convenient and suitable for basic estates.</blockquote>`,
        `<h2>Cons of Using a Free Will Template</h2>`,
        `<ol>
        <li>Limited Customization</li>
        <p>Free will templates often lack the flexibility needed to address more complex estate planning situations.
         If you have unique assets, dependents with special needs, or require a testamentary trust, a free will template may not offer the customization you need.</p>
        <li>Risk of Invalidity</li>
        <p>In South Africa, a will must meet specific legal requirements to be valid. These include being signed in front of two witnesses who are not beneficiaries and ensuring the testator is over 16 years of age and of sound mind. 
        A free will template may not include these critical legal instructions, leading to potential challenges after your passing. </p>
        <li>No Legal Guidance: </li>
        <p>One of the most significant drawbacks of using a free template is the lack of professional advice. Estate planning can be complicated, and without a legal expert’s guidance,
         you may overlook important details such as estate taxes, debts, or how to protect vulnerable beneficiaries.</p>
        <li>Potential for Errors</li>
        <p>Without the proper knowledge, it's easy to make mistakes when drafting a will on your own. Missing information or 
        incorrectly filled-out sections could invalidate your will, leaving your loved ones without clarity and possibly leading to costly legal disputes.</p>
        </ol>`,
        `<blockquote>Free will templates allows limited customization, has the risk unintended errors and being legally invalid, 
        and doesn’t offer legal guidance.</blockquote>`,
        `<h2>When is a Free Will Template a Good Option?</h2>`,
        `<p>For some people, a free will template may be sufficient, especially if:</p>`,
        `<ul>
        <li>You have minimal assets, such as a bank account or personal belongings.</li>
        <li>You do not have dependents or complicated family dynamics.</li>
        <li>Your estate is straightforward, with all assets going to a spouse or one other person.</li>
        <li>You are looking for a temporary solution while you plan a more comprehensive estate plan later on.</li>
        </ul>`,
        `<blockquote>For some people, a free will template may be sufficient, especially if: You have minimal assets, or when 
        your estate is straightforward, with all assets going to a spouse or one other person.</blockquote>`,
        `<h2>When Should You Avoid a Free Will Template?</h2>`,
        `<p>If your estate planning situation is more complex, it’s advisable to avoid relying solely on a free will template. Consider a more robust solution to creating a will if:</p>`,
        `<ul>
        <li>You have minor children or dependents who need a legal guardian.</li>
        <li>You own significant assets, such as property or a business</li>
        <li>You want to set up a testamentary trust to protect your heirs from mismanaging their inheritance.</li>
        <li>You have a blended family, multiple beneficiaries, or potential for family disputes.</li>
        </ul>`,
        `<blockquote>Avoid a free will template if your estate planning situation is more complex. Consider a more robust solution if you have 
        minor children, significant assets, or want to set up a testamentary trust.</blockquote>`,
        `<h2>Key Things to Keep in Mind When Using a Free Will Template</h2>`,
        `<ol>
        <li>Legal Requirements </li>
        <p>Make sure that the will template complies with South Africa's Wills Act of 1953. Your will must be signed in the presence of two witnesses who are not beneficiaries. 
        Failure to meet these legal standards can result in the will being deemed invalid.</p>
        <li>Review Regularly</li>
        <p>A free will template is not a set-and-forget solution. Life circumstances change, such as marriage, divorce, the birth of children, 
        or changes in your financial situation. Regularly review and update your will to reflect your current situation.</p>
        <li>Consider Your Executor</li>
        <p>A free will template will allow you to appoint an executor, but be sure to choose someone who is trustworthy and capable of handling the responsibility.</p>
        <li>Storage and Safety</li>
        <p>Once your will is complete, it’s crucial to keep it in a safe place. Consider a professional service that offers will storage to ensure it is easily accessible when needed.</p>
        </ol>`,
        `<h2>Old Mutual’s Online Will Service - the Smarter Choice</h2>`,
        `<p>Old Mutual's online will service is simple, accessible, with will creation, collection and storage being free of charge, making it one of the most accessible,
         straightforward and trusted options available in South Africa.</p>`,
        `<ol>
        <li>Customised to Your Life</li>
        <p>Every person’s estate and family situation are different. Old Mutual’s online will service walks you through a guided process, helping you address specific needs like providing for minor children, distributing your assets according to your wishes, 
        or offering information that could be helpful to make tax-efficient decisions. Unlike free templates, this service ensures that your will is as unique as your life.</p>
        <li>Expert Support at Every Step</li>
        <p>The thought of creating a will can be daunting, but Old Mutual offers expert-backed support to make the process smooth and stress-free. You'll be confident 
        knowing that your will meets all legal requirements and covers every detail, from asset distribution to appointing a professional executor.</p>
        <li>Simple, Secure, and Convenient</li>
        <p>Creating your will through Old Mutual’s online service is easy and will creation, collection and storage are free of charge. You can complete the process at your own pace, from the comfort of your home, without the need for costly legal consultations. 
        Your will is securely stored and can be easily updated as your life changes, ensuring it always reflects your current wishes.</p>
        <li>Estate Protection Also Available</li>
        <p>Old Mutual also provides additional services like EstateAssist, a range of insurance products which helps cover the costs of settling your estate, including estate administration costs, debt repayment,
         education and cashflow provision. This ensures that your loved ones don’t face financial stress while waiting for your estate to be finalised.</p>
           <blockquote>
           Old Mutual's online will service is simple and accessible, making it one of the most accessible, straightforward and trusted options available in South Africa.
           <ul class="no-paragraphs">
        <li>Customised to Your Life</li>
        <li>Expert Support at Every Step</li>
        <li>Simple, Secure, and Convenient</li>
        <li>Estate Protection Also Available</li>
        </ul>
        </ol>
        </blockquote>`,
        `<h2>Make the Most of Your Estate Planning</h2>
         <p>A will is more than a document—it's about ensuring your loved ones are taken care of when you’re no longer there. While a free will template may offer a quick solution, 
         Old Mutual’s online will service gives you the peace of mind that comes with a thorough, legally valid, and personalized plan.</p>`,
        `<h2>Conclusion: Is a Free Will Template Right for You?</h2>
            <blockquote>A free will template can be a helpful starting point for simple estate planning, 
            but it comes with risks and limitations. If you have a complex estate or want the peace of mind that your will is legally 
            sound and covers all bases, it’s worth considering professional guidance or a more comprehensive will creation service.</blockquote>
          <p>At Old Mutual Will, we provide a straightforward, expert-backed digital will creation process, ensuring that your will meets all legal requirements while being customized to your specific needs.</p>`,
        `<p class="article-cta"><a href="https://${environmentUrl}/register">Create your will</a> today and take control of your future.</p>`,
      ],
    },
    //title "default title"
    {
      id: 10,
      category: "Estate Planning",
      date: "Oct 29, 2024",
      route: "estate-planning-key-to-protecting-your-legacy",
      description: `Estate planning is often viewed as something only the wealthy need, but it’s crucial for anyone who wants to ensure their 
      loved ones are cared for and their assets are distributed according to their wishes. Whether you have a simple estate or a complex financial situation,
       a well-structured estate plan provides peace of mind, minimises taxes, and avoids unnecessary legal complications for your family.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image19.jpg"),
      pathName: "Estate Planning: The Key to Protecting Your Legacy",
      heroTitle: "Estate Planning: Protect Your Legacy and Loved Ones",
      heroDescription:
        "Estate planning isn’t just for the wealthy it ensures your wishes honoured.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle:
        "Estate Planning: The Key to Protecting Your Legacy and Your Loved Ones",
      metaDescription:
        "Estate planning isn’t just for the wealthy—it ensures loved ones are cared for and your wishes honoured. Create your will online today with Old Mutual.",
      content: [
        `<h2 class="mt-0">What is Estate Planning?</h2>`,
        `<p>At its core, estate planning is the process of organising your financial affairs and creating legal documents that outline how your 
          assets will be managed and distributed after your death. Estate planning involves several key components, such as:</p>`,
        `<ul>
          <li><strong>Last Will and Testament</strong></li>
          <p>Specifies how your assets will be distributed, names guardians for your children, and appoints an executor to manage the estate.</p>
          <li><strong>Trusts</strong></li>
          <p>Tools to manage assets on behalf of beneficiaries, especially minors or individuals who may not manage their inheritance responsibly.</p>
          <li><strong>Healthcare Directives</strong></li>
          <p>Living wills and healthcare proxies that outline your medical wishes if you're unable to make decisions.</p>
          <li><strong>Durable Power of Attorney: </strong></li>
          <p>Appoints someone to manage your financial affairs if you become incapacitated.</p>
          </ul>`,
        `<p>Each of these components ensures your estate is handled according to your wishes, providing security and clarity for your loved ones.</p>`,
        `<blockquote>Estate planning is the process of organising your financial affairs and creating legal documents that outline how your assets will be managed and distributed after your death. 
          It provides peace of mind, minimises taxes, and avoids unnecessary legal complications for your family.</blockquote>`,
        `<h2>Why Estate Planning is Important for Everyone</h2>`,
        `<p>You don’t need to have a vast estate to benefit from planning. If you own a home, have savings, 
          or want to ensure your family is looked after, estate planning is essential. Here's why:</p>`,
        `<ol>
          <li>Protecting Your Loved Ones</li>
          <p>Estate planning ensures your family is cared for, whether by designating a guardian for your children, outlining who will inherit your assets, 
          or specifying how your wealth will be distributed.</p>
          <li>Minimising Taxes and Fees</li>
          <p>Proper planning helps reduce estate duties and other taxes that can significantly diminish your estate’s value. 
          Planning helps ensure your heirs receive the maximum benefit.</p>
          <li>Avoiding Legal Battles</li>
          <p>Without an estate plan, the process of distributing your assets can become complicated and may lead to disputes among family members. A comprehensive plan aids in establishing clear instructions for the 
          distribution of your estate as is then captured in your will.</p>
          <li>Ensuring Business Continuity</li>
          <p>If you own a business, estate planning can provide guidelines for its continuation after your passing, 
          ensuring that your legacy continues without disruption.</p>
          </ol>`,
        `<blockquote>You don’t need a large estate to benefit from planning. If you own a home, have savings, 
          or want to ensure your family is looked after, estate planning is essential.</blockquote>`,
        `<h2>Key Components of a Comprehensive Estate Plan</h2>`,
        `<p>A comprehensive estate plan addresses more than just the basics. Here are the essential elements to consider:</p>`,
        `<ol>
          <li>Last will and Testament</li>
          <p>A will is the foundation of your estate plan. It determines how your assets are distributed and outlines critical decisions like naming guardians 
          for minor children and appointing an executor of your estate.</p>
          <li>Setting Up Trusts</li>
          <p>A testamentary trust helps control how and when beneficiaries receive their inheritance, especially if they are minors or require financial protection. 
          A testamentary trust, provides control over how assets are managed for younger heirs.</p>
          <li>Healthcare and Financial Directives</li>
          <p>Including a living will and durable power of attorney ensures your medical and financial affairs are handled according to your preferences if you become incapacitated.</p>
          <li>Planning for Estate Liquidity</li>
          <p>A lack of liquidity can delay settling your estate and may even require selling assets to cover costs. Proper planning ensures enough 
          cash is available to meet estate expenses and taxes without placing a financial burden on your heirs.</p>
          </ol>`,
        `<blockquote>A comprehensive estate plan addresses more than just the basics. It includes a will, trusts, healthcare and financial directives, 
          and plans for estate liquidity to ensure that your loved ones aren’t financially burdened.</blockquote>`,
        `<h2>How Old Mutual Can Help with Your Estate Plan</h2>`,
        `<p>At the heart of any estate plan is a well-crafted will—the cornerstone document that ensures your assets are distributed according to your wishes and all essential elements of your estate are accounted for. However, 
          creating a strong estate plan involves more than just drafting a will. It requires addressing aspects such as taxes, debts, guardianship, and asset management.</p>`,
        `<p>Old Mutual’s digital will creation service provides a guided process that helps you address these critical areas step by step:</p>`,
        `<ul>
          <li><strong>Personalised Guidance</strong></li>
          <p>Our platform asks essential questions to ensure that your will covers the important aspects of your estate plan, such 
          as appointing guardians for your children, distributing assets, and planning for estate liquidity.</p>
          <li><strong>Expert-Backed Support</strong></li>
          <p>You don’t have to navigate the legal complexities of estate planning on your own. Our expert-backed process takes you through a 
          comprehensive, yet straightforward process and provides information and support at every step to help you make the best decisions for your personal situation.</p>
          <li><strong>Flexible and Secure</strong></li>
          <p>Once your will is complete, it is securely stored, and you can easily update it as your life circumstances change. This flexibility ensures that your estate plan as is captured in your will evolves 
          with you, giving you peace of mind that it will always reflect your current wishes.</p>
          </ul>`,
        `<p>In addition, Old Mutual offers supplementary services like EstateAssist, which helps cover the costs of estate administration, debt protection and cash and education 
          provision ensuring that your loved ones are not burdened with unexpected expenses.</p>`,
        `<blockquote>Old Mutual’s digital will creation service provides a guided process covering critical areas of estate planning, like appointing guardians, distributing assets, and planning for estate liquidity. Our expert-backed support ensures a 
          straightforward experience and flexibility to update your will as life changes.</blockquote>`,
        `<h2>Start Planning for the Future Today</h2>`,
        `<p>Estate planning is a vital step in securing your legacy and ensuring your family’s future. Whether you are just starting out or need to update your existing plan, Old Mutual’s digital will creation service provides the tools and expert support 
          you need to create a comprehensive estate plan that protects your loved ones.</p>`,
        `<p class="article-cta"><a href="https://${environmentUrl}/register">Create your will</a> today and take control of your estate planning. </p>`,
      ],
    },
    //title "default title"
    {
      id: 11,
      category: "Wills",
      date: "Oct 29, 2024",
      route: "complete-guide-to-living-wills-and-how-you-can-create-one",
      description: `Planning for the future often means thinking beyond just financial matters—making sure your medical wishes are respected is equally important. 
      This is where a <strong>living will</strong> comes into play. A living will, also known as an advance directive, is a vital document that outlines your preferences for medical treatment if you become unable to communicate your decisions due to illness or incapacity.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image16.jpg"),
      pathName: "A Complete Guide To Living Wills and How You Can Create One",
      heroTitle: "Guide to Living Wills and How to Create One",
      heroDescription:
        "Ensure your medical wishes are respected—create a living will to guide future healthcare decisions.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Guide to Living Wills and How to Create One with Old Mutual",
      metaDescription:
        "Ensure your medical wishes are respected—create a living will to express your healthcare decisions. Included when you create your Old Mutual online will.",
      content: [
        `<h2 class="mt-0">What is a Living Will?</h2>`,
        `<p>A living will is a legal document that allows you to express your wishes regarding medical care in situations where you're unable to make decisions yourself. This document is particularly important in scenarios like terminal illness or permanent unconsciousness. 
        It typically outlines whether you would want life-sustaining treatments, such as mechanical ventilation or resuscitation, or whether you'd prefer to forgo artificial nutrition and hydration when there is no hope of recovery.</p>`,
        `<blockquote>A living will, also known as an advance directive, is a legal document that outlines your preferences for medical treatment if you become unable to communicate your decisions due to illness or incapacity.</blockquote>`,
        `<h2>Why a Living Will is Important in South Africa</h2>`,
        `<p>In South Africa, while living wills are not governed by specific statutes, they are recognised under common law. Healthcare providers generally respect living wills as an expression of a 
        patient’s autonomy, ensuring that your medical treatment aligns with your values when you're unable to advocate for yourself. 
        The South African Medical Association (SAMA) supports the use of clear and specific living wills, which helps avoid ambiguity in critical situations.</p>`,
        `<p>Here are some key reasons to create a living will:</p>`,
        `<ol>
        <li>Control Over Medical Decisions</li>
        <p>A living will ensures that your preferences regarding medical treatments are known and followed, even if you're unable to communicate them yourself.</p>
        <li>Guidance for Healthcare Providers</li>
        <p>It provides clear instructions for doctors and nurses, helping them make decisions that respect your wishes during serious health crises.</p>
        <li>Reduces Family Conflict</li>
        <p>By clearly outlining your medical wishes, a living will can help prevent disputes among family members about the type of care you should receive.</p>
        <li>Peace of Mind</li>
        <p>Knowing that your medical wishes will be respected brings peace of mind, both to you and your loved ones.</p>
        <li>Encourages Open Discussions</li>
        <p>The process of creating a living will fosters discussions about end-of-life care, ensuring that everyone in your family understands and respects your choices.</p>
        </ol>`,
        `<blockquote>
        <h2>Importance of a Living Will:</h2>
        <ul>
        <li><strong>Control</strong></li>
          <p>Ensures your medical wishes are respected.</p>
        <li><strong>Guidance</strong></li>
          <p>Provides clear instructions for healthcare teams.</p>
        <li><strong>Reduces Conflict</strong></li>
          <p>Prevents family disputes over care.</p>
        <li><strong>Peace of Mind</strong></li>
          <p>Reassures you and loved ones.</p>
        <li><strong>Encourages Discussion</strong></li> 
          <p>Sparks vital end-of-life conversations.</p>
        </ul> 
        </blockquote>`,
        `<h2>How a Living Will Differs from a Last Will and Testament</h2>`,
        `<p>It’s important to differentiate between a living will and a last will and testament:</p>`,
        `<ul>
        <li><strong>Living Will</strong></li>
        <p>This document covers your medical care decisions when you're incapacitated and unable to communicate, focusing on healthcare preferences.</p>
        <li><strong>Last Will and Testament</strong></li>
        <p>This document outlines how your assets will be distributed after your death and can include provisions for guardianship of minor children.</p>
        </ul>`,
        `<blockquote>
        <h2>Living Will vs. Last Will and Testament</h2>
        <ol>
        <li>Living Will</li>
          <p>Specifies your medical care preferences if you’re unable to communicate, focusing on healthcare decisions.</p>
        <li>Last Will and Testament</li>
          <p>Directs how your assets are distributed after death, including guardianship of minors and appointing an executor.</p>
        </blockquote>`,
        `<h2>How to Create a Living Will in South Africa</h2>`,
        `<p>Creating a living will is a relatively straightforward process but requires careful consideration. Here are the steps:</p>`,
        `<ol>
        <li>Reflect on Your Preferences</li>
        <p>Consider what treatments you would or wouldn’t want in scenarios such as terminal illness or irreversible coma.</p>
        <li>Consult Healthcare Providers</li>
        <p>It’s important to discuss your medical options with your doctor to understand the implications of different treatments.</p>
        <li>Draft Your Living Will</li>
        <p>Document your preferences clearly, specifying under which conditions you would want or decline life-sustaining treatments.</p>
        <li>Sign and Witness</li>
        <p>Like a legal document, your living will must be signed in the presence of two adult witnesses who are not beneficiaries or healthcare agents.</p>
        <li>Register Your Living Will</li>
        <p>While not legally required, it’s advisable to register your living will with your attorney or healthcare provider to ensure it is accessible when needed.</p>
        <li>Review and Update Regularly</li>
        <p>Life changes, such as significant health events, should prompt a review of your living will to ensure it still reflects your wishes.</p>
        </ol>`,
        `<h2>Creating Your Living Will with Old Mutual’s Online Will Service</h2>`,
        `<p>With Old Mutual’s online will service, you can easily create a living will as part of your broader estate planning process.
         This integrated approach ensures that both your medical and financial wishes are securely documented in a single, comprehensive process. 
         Here’s how Old Mutual can help:</p>`,
        `<ul>
        <li><strong>Guided Process</strong></li>
        <p>Old Mutual’s digital platform takes you through a step-by-step process to create both your last will and testament and your living will. 
        This ensures that all aspects of your estate and medical preferences are covered.</p>
        <li><strong>Expert-Backed Assurance</strong></li>
        <p>The service is designed with expert support, ensuring that your living will and estate plan meet all legal 
        requirements and are easily enforceable when needed.</p>
        <li><strong>Secure Storage and Easy Updates</strong></li>
        <p>Once your living will is created, it is securely stored and can be updated as your medical preferences or family circumstances change,
         giving you peace of mind that your wishes will always be up-to-date.</p>
        </ul>`,
        `<p>With Old Mutual, you’re not just drafting a will—you’re creating a plan that includes both your financial and healthcare wishes.</p>`,
        `<blockquote>Old Mutual’s online will creation service provides a guided, expert-backed process to create both your last will and testament and living will, 
        ensuring all aspects of your estate and medical preferences are securely documented.</blockquote>`,
        `<h2>Take Control of Your Future Today</h2>`,
        `<p>A living will is an essential part of ensuring your end-of-life care reflects your values and preferences. Whether you’re just beginning to plan or updating your estate, 
        Old Mutual’s online will service offers a simple, secure, and expert-backed way to create both your 
        living will and last will and testament in one streamlined process.</p>`,
        `<p class="article-cta"><a href="https://${environmentUrl}/register">Create your will</a> and living will today, ensuring your wishes are respected and your loved ones are taken care of. </p>`,
      ],
    },
    //title:Impact of Marital Regime on Estate Planning
    {
      id: 12,
      category: "Estate Planning",
      date: "Mar 10, 2025",
      route: "the-impact-of-your-marital-regime-on-estate-planning",
      description: `Your marital regime significantly influences your estate planning in 
      South Africa. Whether you are married in community of property, out of community of 
      property with accrual, or out of community of property without accrual, each regime 
      determines how your assets are owned, managed, and distributed upon your passing.
      Understanding these differences is essential to ensure your estate plan aligns with your 
      financial and family goals.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image20.jpg"),
      pathName: "The Impact of Your Marital Regime on Estate Planning",
      heroTitle: "The Impact of Your Marital Regime on Estate Planning",
      heroDescription:
        "Understanding the significance of marital regimes in estate planning",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Guide to Living Wills and How to Create One with Old Mutual",
      metaDescription:
        "Ensure your medical wishes are respected—create a living will to express your healthcare decisions. Included when you create your Old Mutual online will.",
      content: [
        `<h2 class="mt-0">Estate Planning Under Different Marital Regimes</h2>`,
        `<blockquote>Your marital regime determines your asset distribution, legal obligations, and tax liabilities after death. Make informed 
        <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link"> estate planning</a> 
        decisions by understanding these implications.</blockquote>`,
        `<ol>
        <li>In Community of Property</li>
        <h2 class="sub-heading-two">How It Works</h2>
        <p>If you are married in community of property (ICOP), you and your spouse share a joint estate, 
        which includes all assets and liabilities, regardless of when they were acquired. Upon the death of one spouse, 
        the estate is dissolved, and the surviving spouse is entitled to 50% of the joint estate.</p>
        <h2 class="sub-heading-two mt-5">Key Estate Planning Implications</h2>
        <ul>
        <li>You can only distribute your 50% share of the estate through your will.</li>
        <li>If you bequeath a shared asset (e.g., a family home) to someone other than your spouse, 
        the asset may need to be sold unless other arrangements are in place.</li>
        </ul>
        <h2 class="sub-heading-two">Tax Considerations</h2>
        <ul>
        <li><a href="/articles/understanding-estate-duty-and-related-taxes-in-south-africa" class="article-link">Estate duty</a> applies to the deceased’s net estate after deducting the surviving spouse’s share.</li>
        <li><a href="/articles/understanding-estate-duty-and-related-taxes-in-south-africa" class="article-link">Estate duty</a>, a tax levied on the net value of the deceased’s estate, is calculated after deducting 
        the surviving spouse’s share. For estates exceeding the R3.5 million threshold, estate duty is imposed at a 
        rate of 20% for amounts up to R30 million and 25% for amounts exceeding R30 million.</li>
        <li>All debts must be settled before assets are distributed to beneficiaries.</li>
        </ul>
        <li>Out of Community of Property with Accrual</li>
        <h2 class="sub-heading-two">How It Works</h2>
        <p>In this regime, each spouse retains their own estate during the marriage, but upon dissolution (death or divorce), 
        the accrual system applies. The surviving spouse is entitled to half of the growth in the combined net estates.</p>
        <h2 class="sub-heading-two">Key Estate Planning Implications</h2>
        <ul>
        <li>If the deceased spouse’s estate has grown more than the surviving spouse’s estate, the surviving spouse has a 
        <strong>legal claim</strong> against the estate.</li>
        <li>This claim must be settled <strong>before</strong> assets are distributed according to the will, which can 
        lead to liquidity issues.</li>
        </ul>
         <h2 class="sub-heading-two">Tax Considerations</h2>
        <ul>
        <li>The accrual claim is exempt from estate duty under the spousal exemption, meaning it does not 
        ncrease the dutiable value of the estate.</li>
        <li>If the surviving spouse waives the accrual claim, it may be considered a <strong>donation</strong>, which could trigger donations tax.</li>
        <li>Capital Gains Tax (CGT) applies to asset transfers, but CGT on assets transferred to a surviving spouse is deferred until the 
        surviving spouse sells the assets or dies.</li>
        </ul>
        </ol>`,
        `<CreateYourWillBanner bannerText="Protect your family's future" />`,
        `<ol start="3">
        <li>Out of Community of Property Without Accrual</li>
        <h2 class="sub-heading-two">How It Works</h2>
        <p>Each spouse retains <strong>full ownership</strong> of their assets,
        both during the marriage and after death. There is no sharing of estate growth, and each estate is handled separately.</p>
         <h2 class="sub-heading-two">Key Estate Planning Implications</h2>
        <ul>
        <li>The deceased spouse has full testamentary freedom over their estate.</li>
        <li>Without proper planning, the surviving spouse may <strong>not automatically inherit</strong>, especially if financially dependent on the deceased.</li>
        <li>If the family home is owned solely by the deceased, the surviving spouse may not have a right to it unless specified in the will.</li>
        </ul>
         <h2 class="sub-heading-two">Tax Considerations</h2>
        <ul>
        <li>The deceased's estate is liable for estate duty on any amount exceeding R3.5 million, after deducting all 
        allowable deductions and exemptions.</li>
        <li>Since there’s no automatic transfer of assets between spouses, as in the other regimes, 
        the estate may be taxed more heavily, particularly in the absence of proper 
        <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a>.
        </li>
        <li>Capital Gains Tax (CGT) applies, but spousal rollovers can delay taxation.</li>
        </ul>
        </ol>`,
        `<h2 class="mt-0">Maintenance Claims for Surviving Spouses</h2>`,
        `<p>Regardless of the marital regime, South African law imposes a duty of support between spouses that continues after death. 
        The surviving spouse can claim maintenance from the deceased’s estate if they cannot meet their reasonable needs from their own estate, 
        taking precedence over other bequests. This claim takes precedence over other inheritances and can reduce the estate’s liquidity.</p>`,
        `<p>Factors influencing maintenance claims include:</p>`,
        `<ul>
        <li>The estate’s total value.</li>
        <li>The duration of the marriage.</li>
        <li>The surviving spouse’s standard of living and financial situation.</li>
        </ul>`,
        `<h2 class="mt-0">Conclusion</h2>`,
        `<p>Your marital regime plays a pivotal role in shaping your estate plan. From inheritance rights to tax implications, 
        understanding how your marriage contract affects your estate can prevent legal complications and ensure that your 
        loved ones are financially secure.</p>`,
        `<p class="om-green">Plan your estate with confidence. <a href="/register" class="article-link">Create or update</a> your will with Old Mutual Will today.</p>`,
      ],
    },
    {
      id: 13,
      category: "Estate Planning",
      date: "Mar 10, 2025",
      route: "understanding-estate-duty-and-related-taxes-in-south-africa",
      description: `Estate duty is an important tax consideration when planning 
      the distribution of your assets after death. In South Africa, estate duty is 
      levied by the South African Revenue Service (SARS) on the net value of a deceased 
      person's estate before it is transferred to beneficiaries. Understanding 
      how estate duty works, along with related taxes such as capital gains tax (CGT), 
      can help you structure your estate to minimize tax liabilities and protect your legacy.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image21.jpg"),
      pathName: "Understanding Estate Duty and Related Taxes in South Africa",
      heroTitle: "Understanding Estate Duty and Related Taxes in South Africa",
      heroDescription:
        "Navigating estate duty and taxes in South Africa: Tips for effective estate planning",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      metaTitle: "Guide to Living Wills and How to Create One with Old Mutual",
      metaDescription:
        "Ensure your medical wishes are respected—create a living will to express your healthcare decisions. Included when you create your Old Mutual online will.",
      content: [
        `<h2 class="mt-0">What is Estate Duty?</h2>`,
        `<p>Estate duty is a tax imposed on the net dutiable value of a deceased estate.
      It applies once all debts and permissible deductions have been accounted for.</p>`,
        `<h2 class="mt-0">How Estate Duty is Calculated</h2>`,
        `<ul>
      <li><strong>Exemption Threshold:</strong> 
      The first R3.5 million of the estate is exempt from estate duty.
      </li>
       <li>
       <strong>Portability for Spouses:</strong> If the exemption is not fully used, 
       the remainder can be transferred to the surviving spouse, effectively increasing the exemption to <strong>R7 million</strong>.
       </li>
        <li><strong>Estate Duty Rates:</strong></li>
          <ul>
            <li><strong>20%</strong> on the portion of the estate up to <strong>R30 million</strong>.</li>
            <li><strong>25%</strong> on the portion exceeding <strong>R30 million</strong>.</li>
          </ul>
      </ul>`,
        `<h2 class="mt-0">Key Exemptions and Deductions</h2>`,
        `<p>To minimize the taxable estate, certain deductions and exemptions apply:</p>`,
        `<h2 class="sub-heading-one mt-0">Spousal Exemption</h2>`,
        `<p>Any assets left to a <strong>surviving spouse</strong> are exempt from estate duty. This exemption allows spouses to transfer assets without 
      immediate tax consequences.</p>`,
        ` <h2 class="sub-heading-one mt-0">Deductions Allowed Against the Estate</h2>`,
        `<p>Several deductions help reduce the dutiable value of the estate, including:</p>`,
        `<ul>
      <li><strong>Funeral and Deathbed Expenses</strong> – Costs related to medical care and burial.</li>
      <li><strong>Outstanding Debts</strong> – Any liabilities the deceased had at the time of death.</li>
      <li><strong>Executor and Administration Fees</strong> – Legal, accounting, and executor fees incurred during estate administration.</li>
      <li><strong>Charitable Bequests</strong> – Donations to registered public benefit organizations.</li>
      </ul>`,
        `<blockquote>
        Proper <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a> can reduce the impact of estate duty, ensuring your assets are distributed efficiently to your loved ones.
      </blockquote>`,
        `<h2 class="mt-0">Capital Gains Tax (CGT) at Death</h2>`,
        `<p>Upon death, SARS considers all assets as if they were disposed of at market value immediately before death, 
      triggering CGT. This tax is separate from estate duty and applies to asset appreciation.</p>`,
        `<h2 class="sub-heading-two mt-0">Key CGT Exclusions and Rollovers</h2>`,
        `<ul>
      <li><strong>Primary Residence Exclusion:</strong> The first <strong>R2 million</strong> of capital gains on a primary residence is excluded.</li>
      <li><strong>Spousal Rollover Relief:</strong> No CGT is payable on assets left to a spouse until they are sold or the spouse passes away.</li>
      <li><strong>Small Business Relief:</strong> Up to <strong>R1.8 million</strong> in capital gains may be excluded if the business value does not exceed <strong>R10 million</strong>.</li>
      <li><strong>Annual CGT Exclusion:</strong> The first <strong>R300,000</strong> of net capital gains in the year of death is tax-free.</li>
      </ul>`,
        `<CreateYourWillBanner bannerText="Protect your legacy" />`,
        `<h2 class="mt-0">Estate Liquidity and the Impact on Beneficiaries</h2>`,
        `<p>Since estate duty and CGT must be settled before distributing assets to beneficiaries, 
        <a href="/articles/estate-liquidity-the-importance-of-protecting-your-estate" class="article-link">liquidity</a> is a critical factor in 
      <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a>.
      If the estate lacks sufficient cash flow, the executor may be forced to sell assets to cover taxes and administration fees, 
      which can impact beneficiaries’ inheritance.</p>`,
        `<blockquote>Ensuring your estate has sufficient <a href="/articles/estate-liquidity-the-importance-of-protecting-your-estate" class="article-link">liquidity</a> can prevent forced asset sales and ensure your loved ones 
      receive their intended inheritance.</blockquote>`,
        `<h2 class="mt-0">How Old Mutual Will Can Help</h2>`,
        `<p>Old Mutual Will provides information and support to help you navigate 
      <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a> considerations. 
      Our platform allows you to structure your will effectively and ensure your assets are distributed according to your wishes.</p>`,
        `<p>We offer:<p>`,
        `<ul>
      <li>Secure and user-friendly online will creation.</li>
      <li>Access to a <a href="/estate-administration-cost-calculator" class="article-link">cost calculator</a> that will help you understand the cost implications of winding up your estate</li>
      <li>Information on structuring your estate to align with South African laws.</li>
      </ul>`,
        `<h2 class="mt-0">Conclusion</h2>`,
        `<p>Understanding estate duty and related taxes is crucial for effective <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a>. By knowing how your estate will be 
      taxed and taking advantage of available exemptions, you can minimize financial burdens on your heirs. Planning ahead ensures 
      that your estate is structured efficiently, reducing unnecessary tax liabilities and ensuring a smooth 
      transition for your loved ones.</p>`,
        `<p class="om-green"><a href="/register" class="article-link">Create your will</a> online with Old Mutual Will to protect your legacy.</p>`,
      ],
    },
    {
      id: 14,
      category: "Estate Planning",
      date: "Mar 10, 2025",
      route: "understanding-the-implications-of-debt-settlement-after-death",
      description: `Debt does not disappear when you pass away—it becomes part of 
      your estate, and the responsibility to settle outstanding balances falls on 
      your executor. In South Africa, creditors have the right to claim what is owed 
      from the deceased’s estate before any assets are distributed to beneficiaries. 
      Understanding how different types of debt are handled can help you plan 
      your estate effectively and protect your loved ones from unnecessary financial burdens.`,
      imageUrl: require("@/assets/shared/redesign/articles/Article-image22.jpg"),
      pathName: "Understanding the implications of debt settlement after death",
      heroTitle: "What Happens to Your Debt When You Die?",
      heroDescription:
        "Understanding the implications of debt settlement after death",
      metaTitle: "Guide to Living Wills and How to Create One with Old Mutual",
      metaDescription:
        "Ensure your medical wishes are respected—create a living will to express your healthcare decisions. Included when you create your Old Mutual online will.",
      heroButtonText: "Create Your Will",
      heroButtonLink: "Register",
      content: [
        `<blockquote>
        Your estate is responsible for paying your debts first—beneficiaries receive what remains after all liabilities are settled.
        </blockquote>`,
        `<h2 class="mt-0">How Debt is Handled After Death</h2>`,
        `<ol>
        <li>The Executor’s Role</li>
        <p>When someone passes away, the appointed <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> 
        takes responsibility for settling their financial affairs. This involves:</p>
        <ul>
        <li>Identifying all outstanding debts and notifying creditors.</li>
        <li>Assessing the estate’s assets and liquid funds.</li>
        <li>Settling debts before distributing assets to beneficiaries.</li>
        <li>Ensuring legal compliance with estate administration laws.</li>
        </ul>
        <p class="last">If the estate lacks sufficient liquid assets, the <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> may have to sell certain assets to cover debts, 
        which could impact what beneficiaries inherit.</p>
       <li>Secured vs. Unsecured Debt</li>
       <p>Not all debts are treated the same way. Understanding the distinction between secured and unsecured debt is crucial:</p>
       <ul>
        <li><strong>Secured Debt:</strong> This includes home loans and vehicle finance, where an asset serves as collateral. If the estate cannot settle the debt,
          creditors may repossess the asset.</li>
        <li><strong>Unsecured Debt:</strong> This includes credit cards, personal loans, and student loans, which are not tied to any asset. 
        These debts are paid from the estate, and if insufficient funds exist, creditors may have to write off the remaining balance.</li>
       </ul>
       <li>Debt in Joint Accounts or Co-Signed Loans</li>
       <ul>
       <li>If a debt is <strong>jointly held</strong>, the surviving co-account holder may become fully responsible for the outstanding balance.</li>
       <li>If someone has <strong>guaranteed</strong> a loan, they may be legally obligated to continue repaying it after the primary borrower’s passing.</li>
       </ul>
        </ol>`,
        `<blockquote>Joint debts do not disappear—co-signers or surviving account holders may inherit full responsibility.</blockquote>`,
        `<CreateYourWillBanner bannerText="Protect your family's future" />`,
        `<h2 class="mt-0">What Happens If the Estate Cannot Pay the Debt?</h2>`,
        `<p>If the estate lacks sufficient assets to settle debts, it is declared insolvent, meaning creditors will only receive partial 
        repayment or may need to write off certain debts. Beneficiaries are not required to pay off the deceased’s debt
         unless they were co-signers or guarantors of the loan.</p>`,
        `<h2 class="mt-0">Planning Ahead to Manage Debt</h2>`,
        `<p><a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">Estate planning</a>
         helps mitigate the financial strain that debt can impose on your loved ones. Consider these steps:</p>`,
        `<ol>
         <li>Maintain Sufficient Life Insurance</li>
         <p>A life insurance policy can help cover outstanding debts and prevent the need to liquidate assets intended for beneficiaries.</p>
         <li>Draft a Clear and Legally Binding Will</li>
         <p>Having an updated will ensures that your <a href="/articles/executor-of-will-why-do-you-need-a-professional-executor" class="article-link">executor</a> can settle your debts efficiently while preserving as much of 
         your estate as possible for your heirs.</p>
         <li>Reduce Outstanding Debt During Your Lifetime</li>
         <p>Managing debt proactively—by paying off high-interest loans and reducing liabilities—ensures that more 
         of your estate remains intact for your loved ones.</p>
         <blockquote>Planning ahead can protect your beneficiaries from unnecessary financial hardship and ensure a 
         smoother estate settlement process.</blockquote>
         </ol>`,
        `<h2 class="mt-0">How Old Mutual Will Can Help</h2>`,
        `<p>Old Mutual Will provides an easy-to-use platform that helps you create a legally valid will while considering essential <a href="/articles/estate-planning-key-to-protecting-your-legacy" class="article-link">estate planning</a> factors, 
         including debt management. We provide factual guidance on:</p>`,
        `<ul>
         <li>Ensuring your estate can meet debt obligations.</li>
          <li>Structuring your will to manage outstanding liabilities effectively.</li>
          <li>Offer a range of solutions that helps you to protect and optimise the position of your estate</li>
         </ul>`,
        `<blockquote>Take control of your estate today — create your will with Old Mutual Will to protect your assets and beneficiaries.</blockquote>`,
        `<p>Debt does not simply disappear after death—it is settled through your estate, which can impact what your beneficiaries inherit. By understanding how debt is managed, planning ahead, and taking steps to minimize liabilities, 
         you can ensure your loved ones are not burdened with unnecessary financial stress.</p>`,
        `<p class="om-green">Ensure your estate is structured correctly. Protect your loved ones – <a href="/register" class="article-link">create your will</a> with Old Mutual Will.</p>`,
      ],
    },
  ],
};
